import { forEach } from "lodash";
import { SERVER_URL } from "../config/config.js";
import {
  additionalFilterOnInputForBilty,
  additionalFilterOnResponseForGetEwb,
  mapBvtcBigToTruckSize,
} from "../utils/biltyUtils.js";
import { additionalFilterOnInputForMr } from "../utils/mrUtils.js";
import convertToUpperCase from "../utils/convertToUpperCase.js";

const lodash = require("lodash");

const biltyApiConfig = {
  getBilty: {
    responseSchema: {
      pf: "same",
      invoice_no: "same",
      lr_no: "same",
      booking_lr_date: "same",
      tbb_paid_memo_no: "same",
      mr_type: "same",
      paid_due: "same",
      paid_due_name: "same",
      loading_charge: "same",
      unloading_charge: "same",
      station_from_mobile: "same",
      station_to_mobile: "same",
      bill_no: "same",
      no_of_package: "same",
      bilty_no: "same",
      other_amount: "same",
      actual_weight: "same",
      freight: "same",
      station_from: "same",
      charge_weight: "same",
      station_to: "same",
      hamali: "same",
      packing_type: "same",
      destination: "same",
      vehicle_no: "same",
      door_del_charge: "same",
      lc_charge: "same",
      private_marka_no: "same",
      pay_type: "same",
      goods_invoice_value: "same",
      consignor_id: "same",
      delivery_dest_type: "same",
      bilty_id: "same",
      consignee_id: "same",
      remarks: "same",
      bilty_charge: "same",
      consignee_address: "same",
      consignor_address: "same",
      consignor_name: "same",
      consignee_name: "same",
      consignor_gst: "same",
      consignee_gst: "same",
      consignor_mobile: "same",
      consignor_mobile_no: "same",
      consignee_mobile: "same",
      consignee_mobile_no: "same",
      station_from_mobile: "same",
      station_from_name: "same",
      station_to_mobile: "same",
      station_to_name: "same",
      destination_name: "same",
      item_info: "item_in",
      eway_bill_info: "eway_bill_no",
      is_deleted: "same",
      bilty_date: "input_date",
      billing_party: "same",
      billing_party_name: "same",
      booking_chalan_no: "same",
      mr_no: "same",
      trip_no: "same",
      total_amount: "same", // what for same ?
      transporter_id: "same",
      transporter_name: "same",
      suffix: "same",
      transporter_freight: "same",
      crossing_inward_no: "same",
      fyear: "fYear_get",
      consignee2_name: "same",
      consignee2_id: "same",
      consignee2_gst: "same",
      mobile_number:"same",
      second_consignor_id:"same",
      third_consignor_id:"same",
      second_consignee_id:"same",
      third_consignee_id:"same",
      address_consignor:"same",
      second_consignee_address:"same",
      address_consignee:"same",
      second_consignor_address:"same",
      third_consignor_address:"same",
      third_consignee_address:"same",
      second_consignor_name:"same",
      second_consignor_gst:"same",
      third_consignor_name:"same",
      third_consignor_gst:"same",
      second_consignee_name:"same",
      second_consignee_gst:"same",
      third_consignee_name:"same",
      third_consignee_gst:"same",
      po_no:"same",
      lot_no:"same",
      pr_no:"same",
      no_of_consignors:"same",
      no_of_consignees:"same",
      rto:"same",
      advance:"same",
      detention:"same",
      lot_no1: "same",
      pr_no1: "same",
      payment_type:"same",
      is_pod_image: "same",
      loaded_by_name: "same",
      discount: "same",
      reference_no: "same",
      crossing_charge: "same",
    },
    url: SERVER_URL + "/bilty/",
    methodType: "GET",
    additionalFilterOnResponse: (inputObject) => {
      console.log("Input object", inputObject);
      if (Array.isArray(inputObject.item_info) && inputObject.item_info.length > 0) {
        inputObject.item_info = mapBvtcBigToTruckSize(inputObject.item_info);
      } else if (process.env.REACT_APP_CLIENT === "bvtc") {
        inputObject.item_info = [
          {
            amount: "",
            item_name: "",
            pkgs: "",
            rate: "",
            unit: "C",
            weight: "",
            new_row: "N",
            packing_type: "1",
            truck_size: "",
            rate_info: [],
          },
        ];
      } else {
        delete inputObject.item_info;
      }
      if (inputObject.eway_bill_info?.length == 0) {
        inputObject.eway_bill_info = [
          {
            eway_bill_no: "",
            new_row: "N",
          },
        ];
      }
      if (inputObject.is_pod_image != "") {
        inputObject.is_pod_image = inputObject.is_pod_image;
      }
      return inputObject;
    },
  },
  getEwbInfo: {
    responseSchema: {
      consignor_id: "same",
      consignor_name: "same",
      consignee_name: "same",
      consignor_gst: "same",
      consignee_gst: "same",
      consignee_id: "same",
      private_marka_no: "same",
      goods_invoice_value: "same",
    },
    url: SERVER_URL + "/ewb/",
    methodType: "POST",
    additionalFilterOnResponse: additionalFilterOnResponseForGetEwb,
  },
  saveBilty: {
    paramSchema: {
      pf: "same",
      invoice_no: "same",
      lr_no: "same",
      booking_lr_date: "same",
      tbb_paid_memo_no: "same",
      mr_type: "same",
      paid_due: "same",
      paid_due_name: "same",
      second_consignor_address:"same",
      third_consignor_address:"same",
      loading_charge: "same",
      unloading_charge: "same",
      station_from_mobile: "same",
      station_to_mobile: "same",
      no_of_package: "same",
      bilty_no: "same",
      other_amount: "same",
      actual_weight: "same",
      freight: "same",
      station_from: "same",
      charge_weight: "same",
      station_to: "same",
      hamali: "same",
      packing_type: "same",
      destination: "same",
      door_del_charge: "same",
      lc_charge: "same",
      vehicle_no: "same",
      private_marka_no: "same",
      pay_type: "same",
      goods_invoice_value: "same",
      billing_party: "same",
      billing_party_name: "same",
      consignor_id: "same",
      delivery_dest_type: "same",
      // "bilty_id": "same",
      consignee_id: "same",
      remarks: "same",
      bilty_charge: "same",
      consignee_address: "same",
      consignor_address: "same",
      consignor_name: "same",
      consignee_name: "same",
      consignor_gst: "same",
      consignee_gst: "same",
      station_from_name: "same",
      station_from_mobile:"same",
      station_to_mobile:"same",
      station_to_name: "same",
      destination_name: "same",
      item_in: "same",
      created_by: "same",
      created_from: "same",
      delivery_dest_type: "same",
      pay_type: "same",
      packing_type: "same",
      // "is_printed": "same",
      eway_bill_no: "eway_bill_info",
      input_date: "bilty_date",
      total_amount: "same",
      total_amount: "same",
      transporter_id: "same",
      transporter_name: "same",
      suffix: "same",
      transporter_freight: "same",
      is_crossing: "same",
      company_id: "companyId",
      fYear: "fyear",
      consignee2_name: "same",
      consignee2_id: "same",
      consignee2_gst: "same",
      mobile_number:"same",
      second_consignor_name:"same",
      second_consignor_gst:"same",
      third_consignor_name:"same",
      third_consignor_gst:"same",
      second_consignee_name:"same",
      second_consignee_gst:"same",
      third_consignee_name:"same",
      third_consignee_gst:"same",
      pr_no:"same",
      lot_no:"same",
      po_no:"same",
      second_consignor_id:"same",
      third_consignor_id:"same",
      address_consignor:"same",
      second_consignee_address:"same",
      address_consignee:"same",
      third_consignee_address:"same",
      second_consignee_id:"same",
      third_consignee_id:"same",
      no_of_consignors:"same",
      no_of_consignees:"same",
      detention:"same",
      rto:"same",
      advance:"same",
      lot_no1: "same",
      pr_no1: "same",
      payment_type:"same",
      loaded_by: "same",
      // loaded_by_id: "same",
      discount: "same",
      consignor_mobile_no: "same",
      consignee_mobile_no: "same",
      reference_no: "same",
      crossing_charge: "same",
    },
    responseSchema: {
      bilty_no: "same",
      consignor_id: "same",
      consignee_id: "same",
    },
    url: SERVER_URL + "/bilty/",
    methodType: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      if (!text.bilty_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
    additionalFilterOnInput: (inputObject) => additionalFilterOnInputForBilty(inputObject, "POST")
  },
  modifyBilty: {
    paramSchema: {
      pf: "same",
      invoice_no: "same",
      lr_no: "same",
      booking_lr_date: "same",
      tbb_paid_memo_no: "same",
      mr_type: "same",
      paid_due: "same",
      paid_due_name: "same",
      second_consignor_address:"same",
      third_consignor_address:"same",
      loading_charge: "same",
      unloading_charge: "same",
      station_from_mobile: "same",
      station_to_mobile: "same",
      bilty_id: "same",
      no_of_package: "same",
      bilty_no: "same",
      other_amount: "same",
      actual_weight: "same",
      freight: "same",
      station_from: "same",
      charge_weight: "same",
      station_to: "same",
      vehicle_no: "same",
      hamali: "same",
      packing_type: "same",
      destination: "same",
      billing_party: "same",
      billing_party_name: "same",
      door_del_charge: "same",
      lc_charge: "same",
      private_marka_no: "same",
      pay_type: "same",
      goods_invoice_value: "same",
      consignor_id: "same",
      delivery_dest_type: "same",
      // "bilty_id": "same",
      consignee_id: "same",
      remarks: "same",
      bilty_charge: "same",
      consignee_address: "same",
      consignor_address: "same",
      consignor_name: "same",
      consignee_name: "same",
      consignor_gst: "same",
      consignee_gst: "same",
      station_from_name: "same",
      station_from_mobile:"same",
      station_to_mobile:"same",
      station_to_name: "same",
      destination_name: "same",
      item_in: "same",
      created_by: "same",
      created_from: "same",
      delivery_dest_type: "same",
      pay_type: "same",
      packing_type: "same",
      // "is_printed": "same",
      eway_bill_no: "eway_bill_info",
      input_date: "bilty_date",
      total_amount: "same",
      total_amount: "same",
      transporter_id: "same",
      transporter_name: "same",
      suffix: "same",
      transporter_freight: "same",
      is_crossing: "same",
      company_id: "companyId",
      fYear_get: "fyear",
      consignee2_name: "same",
      consignee2_id: "same",
      consignee2_gst: "same",
      mobile_number:"same",
      second_consignor_name:"same",
      second_consignor_gst:"same",
      third_consignor_name:"same",
      third_consignor_gst:"same",
      second_consignee_name:"same",
      second_consignee_gst:"same",
      third_consignee_name:"same",
      third_consignee_gst:"same",
      lot_no:"same",
      po_no:"same",
      pr_no:"same",
      second_consignor_id:"same",
      third_consignor_id:"same",
      second_consignee_id:"same",
      third_consignee_id:"same",
      address_consignor:"same",
      second_consignee_address:"same",
      address_consignee:"same",
      third_consignee_address:"same",
      rto:"same",
      advance:"same",
      detention:"same",
      no_of_consignors:"same",
      no_of_consignees:"same",
      lot_no1: "same",
      pr_no1: "same",
      payment_type:"same",
      loaded_by: "same",
      // loaded_by_id: "same",
      discount: "same",
      consignor_mobile_no: "same",
      consignee_mobile_no: "same",
      reference_no: "same",
      crossing_charge: "same",
    },
    responseSchema: {
      bilty_no: "same",
      consignor_id: "same",
      consignee_id: "same",
    },
    url: SERVER_URL + "/bilty/",
    methodType: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      if (!text.bilty_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
    additionalFilterOnInput: (inputObject) => additionalFilterOnInputForBilty(inputObject, "PUT")
  },
  getCitySuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/branch/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getVehicleSuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/vehicle/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getConsignorSuggestions: {
    url: SERVER_URL + "/consignor/",
    methodType: "GET",
    respoonseSchema: {},
    paramSchema: {
      pay_type: "same",
    },
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  },
  getConsigneeSuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/consignee/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getConsigneeSuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/consignee/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getItemSuggestions: {
    url: SERVER_URL + "/item/id",
    methodType: "POST",
    respoonseSchema: {},
    tailTruncate: true,
  },
  getTransporterSuggestions: {
    url: SERVER_URL + "/transporter/",
    methodType: "POST",
    respoonseSchema: {},
  },
};

const biltyInquiryApiConfig = {
  getBiltyInquiry: {
    responseSchema: {
      pf: "same",
      no_of_package: "same",
      bilty_no: "same",
      other_amount: "same",
      actual_weight: "same",
      freight: "same",
      station_from: "same",
      tbb_bill_no: "same",
      tbb_bill_date: "same",
      charge_weight: "same",
      station_to: "same",
      hamali: "same",
      packing_type: "same",
      destination: "same",
      door_del_charge: "same",
      private_marka_no: "same",
      pay_type: "same",
      goods_invoice_value: "same",
      consignor_id: "same",
      delivery_dest_type: "same",
      bilty_id: "same",
      consignee_id: "same",
      remarks: "same",
      bilty_charge: "same",
      consignor_name: "same",
      consignee_name: "same",
      consignor_gst: "same",
      consignee_gst: "same",
      station_from_name: "same",
      station_to_name: "same",
      destination_name: "same",
      item_info: "item_in",
      eway_bill_info: "eway_bill_no",
      is_deleted: "same",
      marfatiya: "same",
      mr_party_name: "same",
      mr_date: "same",
      mr_bill_no: "same",
      mr_total_amount: "same",
      mr_receiver_name: "same",
      pod_chalan_date: "same",
      bilty_date: "input_date",
      paid_statement_no: "same",
      paid_statement_date: "same",
      crossing_inward_no: "same",
      crossing_inward_date: "same",
      crossing_outward_no: "same",
      crossing_outward_date: "same",
      crossing_outward_transporter: "same",
      crossing_outward_branch: "same",
      crossing_inward_branch: "same",
      booking_chalan_no: "same",
      mr_no: "same",
      trip_no: "same",
      total_amount: "same",
      transporter_id: "same",
      transporter_name: "same",
      chalan_info: "same",
      suffix: "same",
      transporter_freight: "same",
      crossing_inward_no: "same",
      owned_by_name: "same",
      pod_statement_no: "same",
      pod_statement_date: "same",
      fyear: "fYear_get",
      flag: "flag",
      pod_chalan_no: "same",
      is_pod_image: "same",
      billing_party: "same",
      billing_party_name: "same",
      tempo_collection: "same",
      local_delivery_no: "same",
      local_delivery_date: "same",
      reference_no: "same",
    },
    url: SERVER_URL + "/bilty/",
    methodType: "GET",
    additionalFilterOnResponse: (inputObject) => {
      console.log("Input object", inputObject);
      inputObject.item_info = mapBvtcBigToTruckSize(inputObject.item_info);
      if (inputObject.eway_bill_info?.length == 0) {
        inputObject.eway_bill_info = [
          {
            eway_bill_no: "",
            new_row: "N",
          },
        ];
      }
      if (inputObject.is_pod_image != "") {
        inputObject.is_pod_image = inputObject.is_pod_image;
      }
      if (
        inputObject.local_delivery_date &&
        typeof inputObject.local_delivery_date === "string" &&
        inputObject.local_delivery_date.includes("T")
      ) {
        inputObject.local_delivery_date =
          inputObject.local_delivery_date.split("T")[0];
      }

      return inputObject;
    },
  },
  getEwbInfo: {
    responseSchema: {
      consignor_id: "same",
      consignor_name: "same",
      consignee_name: "same",
      consignor_gst: "same",
      consignee_gst: "same",
      consignee_id: "same",
      private_marka_no: "same",
      goods_invoice_value: "same",
    },
    url: SERVER_URL + "/ewb/",
    methodType: "POST",
    additionalFilterOnResponse: additionalFilterOnResponseForGetEwb,
  },
  saveBilty: {
    paramSchema: {
      pf: "same",
      no_of_package: "same",
      bilty_no: "same",
      other_amount: "same",
      actual_weight: "same",
      freight: "same",
      station_from: "same",
      charge_weight: "same",
      station_to: "same",
      hamali: "same",
      packing_type: "same",
      destination: "same",
      door_del_charge: "same",
      private_marka_no: "same",
      pay_type: "same",
      goods_invoice_value: "same",
      consignor_id: "same",
      delivery_dest_type: "same",
      // "bilty_id": "same",
      consignee_id: "same",
      remarks: "same",
      bilty_charge: "same",
      consignor_name: "same",
      consignee_name: "same",
      consignor_gst: "same",
      consignee_gst: "same",
      station_from_name: "same",
      station_to_name: "same",
      destination_name: "same",
      item_in: "same",
      created_by: "same",
      created_from: "same",
      delivery_dest_type: "same",
      pay_type: "same",
      packing_type: "same",
      // "is_printed": "same",
      eway_bill_no: "eway_bill_info",
      input_date: "bilty_date",
      total_amount: "same",
      total_amount: "same",
      transporter_id: "same",
      transporter_name: "same",
      suffix: "same",
      transporter_freight: "same",
      is_crossing: "same",
    },
    responseSchema: {
      bilty_no: "same",
    },
    url: SERVER_URL + "/bilty/",
    methodType: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      if (!text.bilty_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
    additionalFilterOnInput: additionalFilterOnInputForBilty,
  },
  modifyBilty: {
    paramSchema: {
      pf: "same",
      no_of_package: "same",
      bilty_no: "same",
      other_amount: "same",
      actual_weight: "same",
      freight: "same",
      station_from: "same",
      charge_weight: "same",
      station_to: "same",
      hamali: "same",
      packing_type: "same",
      destination: "same",
      door_del_charge: "same",
      private_marka_no: "same",
      pay_type: "same",
      goods_invoice_value: "same",
      consignor_id: "same",
      delivery_dest_type: "same",
      // "bilty_id": "same",
      consignee_id: "same",
      remarks: "same",
      bilty_charge: "same",
      consignor_name: "same",
      consignee_name: "same",
      consignor_gst: "same",
      consignee_gst: "same",
      station_from_name: "same",
      station_to_name: "same",
      destination_name: "same",
      item_in: "same",
      created_by: "same",
      created_from: "same",
      delivery_dest_type: "same",
      pay_type: "same",
      packing_type: "same",
      // "is_printed": "same",
      eway_bill_no: "eway_bill_info",
      input_date: "bilty_date",
      total_amount: "same",
      total_amount: "same",
      transporter_id: "same",
      transporter_name: "same",
      suffix: "same",
      transporter_freight: "same",
      is_crossing: "same",
    },
    responseSchema: {
      bilty_no: "same",
    },
    url: SERVER_URL + "/bilty/",
    methodType: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      if (!text.bilty_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
    additionalFilterOnInput: additionalFilterOnInputForBilty,
  },
  getCitySuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/branch/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getConsignorSuggestions: {
    url: SERVER_URL + "/consignor/",
    methodType: "GET",
    respoonseSchema: {},
    paramSchema: {
      pay_type: "same",
    },
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  },
  getConsigneeSuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/consignee/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getConsigneeSuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/consignee/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getItemSuggestions: {
    url: SERVER_URL + "/item/id",
    methodType: "POST",
    respoonseSchema: {},
    tailTruncate: true,
  },
  getTransporterSuggestions: {
    url: SERVER_URL + "/transporter/",
    methodType: "POST",
    respoonseSchema: {},
  },
};

const biltyAcknowledgementApiConfig = {
  getBiltyInquiry: {
    responseSchema: {
      no_of_package: "same",
      bilty_no: "same",
      other_amount: "same",
      actual_weight: "same",
      freight: "same",
      station_from: "same",
      charge_weight: "same",
      station_to: "same",
      hamali: "same",
      packing_type: "same",
      destination: "same",
      door_del_charge: "same",
      private_marka_no: "same",
      pay_type: "same",
      goods_invoice_value: "same",
      consignor_id: "same",
      delivery_dest_type: "same",
      bilty_id: "same",
      consignee_id: "same",
      remarks: "same",
      bilty_charge: "same",
      consignor_name: "same",
      consignee_name: "same",
      consignor_gst: "same",
      consignee_gst: "same",
      station_from_name: "same",
      station_to_name: "same",
      destination_name: "same",
      item_info: "item_in",
      eway_bill_info: "eway_bill_no",
      is_deleted: "same",
      marfatiya: "same",
      mr_party_name: "same",
      mr_date: "same",
      mr_total_amount: "same",
      mr_receiver_name: "same",
      pod_chalan_date: "same",
      bilty_date: "input_date",
      paid_statement_no: "same",
      paid_statement_date: "same",
      crossing_inward_no: "same",
      crossing_inward_date: "same",
      crossing_outward_no: "same",
      crossing_outward_date: "same",
      crossing_outward_transporter: "same",
      crossing_outward_branch: "same",
      crossing_inward_branch: "same",
      booking_chalan_no: "same",
      mr_no: "same",
      trip_no: "same",
      total_amount: "same",
      transporter_id: "same",
      transporter_name: "same",
      chalan_info: "same",
      suffix: "same",
      transporter_freight: "same",
      crossing_inward_no: "same",
      owned_by_name: "same",
    },
    url: SERVER_URL + "/bilty/",
    methodType: "GET",
    additionalFilterOnResponse: (inputObject) => {
      console.log("Input object", inputObject);
      if (inputObject.eway_bill_info.length == 0) {
        inputObject.eway_bill_info = [
          {
            eway_bill_no: "",
            new_row: "N",
          },
        ];
      }
      return inputObject;
    },
  },
};
const challanApiConfig = {
  getChallan: {
    responseSchema: {
      receiver_name: "same",
      balance_paid: "same",
      balance_paid_date: "same",
      tds_date: "same",
      pan_no: "same",
      billing_party: "same",
      billing_party_name: "same",
      booking_chalan_no: "challan_no",
      station_from: "same",
      station_to: "same",
      destination: "same",
      station_from_name: "same",
      station_to_name: "same",
      destination_name: "same",
      vehicle_id: "same",
      vehicle_no: "same",
      created_from: "same",
      license_no: "same",
      remarks: "same",
      created_by: "same",
      bilty_info: "bilty_ids",
      driver_name: "same",
      owner_name: "same",
      status: "same",
      is_deleted: "same",
      phone_no: "same",
      bilty_no: "",
      No: "",
      booking_chalan_date: "input_date",
      cewb_no: "same",
      cewb_no2: "same",
      is_inwarded: "same",
      manual_no: "same",
      trip_no: "same",
      fyear: "fYear_get",
      transaction_id: "same",
      is_crossing_challan: "same",
      lorry_hire: "same",
      loading: "same",
      detention: "same",
      total: "same",
      advance1: "same",
      advance2: "same",
      advance3:"same",
      advance4:"same",
      advance5:"same",
      diesel_amount: "same",
      commision: "same",
      balance_1: "same",
      balance_2: "same",
      petrol_pump_name: "same",
      diesel_quantity: "same",
      diesel_rate: "same",
      start_km: "same",
      less_deduction: "same",
      delivery_charge: "same",
      height_charge: "same",
      claim_charge: "same",
      late_delivery: "same",
      misc_income: "same",
      hire_charge: "same",
      hamali_charge: "same",
      unloading: "same",
      rto_charge: "same",
      office_mamul: "same",
      other_expense: "same",
      container_charge: "same",
      union_charge: "same",
      unloading_detension_charge: "same",
      incentive_charge: "same",
      extra_point_charge: "same",
      tds: "same",
      payment_type: "same",
      payment_type1: "same",
      payment_type2:"same",
      payment_type3:"same",
      payment_type4:"same",
      payment_type5:"same",
      other: "same",
      billing_party: "same",
      billing_party_name: "same",
      party_rate: "same",
      weight: "same",
      rate:"same",
      adv_bal: "same",
      charge_weight: "same",
      lorry_hire_weight: "same",
      advance_date: "same",
      grand_total_date: "same",
      broker_name: "same",
    },
    url: SERVER_URL + "/challan/",
    methodType: "GET",
  },
  getManualChallan: {
    responseSchema: {
      receiver_name: "same",
      balance_paid: "same",
      balance_paid_date: "same",
      tds_date: "same",
      pan_no: "same",
      billing_party: "same",
      billing_party_name: "same",
      station_from: "same",
      station_to: "same",
      destination: "same",
      station_from_name: "same",
      station_to_name: "same",
      destination_name: "same",
      vehicle_id: "same",
      vehicle_no: "same",
      created_from: "same",
      license_no: "same",
      remarks: "same",
      created_by: "same",
      bilty_info: "bilty_ids",
      driver_name: "same",
      owner_name: "same",
      status: "same",
      is_deleted: "same",
      phone_no: "same",
      bilty_no: "",
      booking_chalan_no: "challan_no",
      booking_chalan_date: "input_date",
      cewb_no: "same",
      cewb_no2: "same",
      is_inwarded: "same",
      multiple_manual_chalan: "same",
      is_crossing_challan: "same",
      lorry_hire: "same",
      loading: "same",
      detention: "same",
      total: "same",
      advance1: "same",
      advance2: "same",
      advance3:"same",
      advance4:"same",
      advance5:"same",
      diesel_amount: "same",
      commision: "same",
      balance_1: "same",
      balance_2: "same",
      petrol_pump_name: "same",
      diesel_quantity: "same",
      diesel_rate: "same",
      start_km: "same",
      less_deduction: "same",
      delivery_charge: "same",
      height_charge: "same",
      claim_charge: "same",
      late_delivery: "same",
      misc_income: "same",
      hire_charge: "same",
      unloading: "same",
      rto_charge: "same",
      office_mamul: "same",
      other_expense: "same",
      container_charge: "same",
      union_charge: "same",
      unloading_detension_charge: "same",
      incentive_charge: "same",
      extra_point_charge: "same",
      tds: "same",
      payment_type: "same",
      payment_type1: "same",
      payment_type2:"same",
      payment_type3:"same",
      payment_type4:"same",
      payment_type5:"same",
      other: "same",
      party_rate: "same",
      weight: "same",
      rate:"same",
      adv_bal: "same",
      charge_weight: "same",
      lorry_hire_weight: "same",
      advance_date: "same",
      grand_total_date: "same",
      broker_name: "same",
    },
    url: SERVER_URL + "/challan/manual/",
    methodType: "GET",
  },
  generateCwb: {
    responseSchema: {
      status: "same",
      cewb_no: "same",
      cewb_no2: "same",
    },
    url: SERVER_URL + "/ewb/consolidated/",
    methodType: "GET",
  },
  saveChallan: {
    paramSchema: {
      receiver_name: "same",
      balance_paid: "same",
      balance_paid_date: "same",
      tds_date: "same",
      pan_no: "same",
      billing_party: "same",
      billing_party_name: "same",
      station_from: "same",
      station_to: "same",
      destination: "same",
      station_from_name: "same",
      station_to_name: "same",
      destination_name: "same",
      vehicle_id: "same",
      vehicle_no: "same",
      created_from: "same",
      license_no: "same",
      remarks: "same",
      created_by: "same",
      bilty_ids: "bilty_nos",
      driver_name: "same",
      owner_name: "same",
      input_date: "booking_chalan_date",
      cewb_no: "same",
      cewb_no2: "same",
      phone_no: "same",
      created_by_name: "same",
      manual_no: "same",
      company_id: "companyId",
      fYear: "fyear",
      is_crossing_challan: "same",
      lorry_hire: "same",
      loading: "same",
      detention: "same",
      total: "same",
      advance1: "same",
      advance2: "same",
      advance3:"same",
      advance4:"same",
      advance5:"same",
      diesel_amount: "same",
      commision: "same",
      balance_1: "same",
      balance_2: "same",
      petrol_pump_name: "same",
      diesel_quantity: "same",
      diesel_rate: "same",
      start_km: "same",
      less_deduction: "same",
      delivery_charge: "same",
      height_charge: "same",
      claim_charge: "same",
      late_delivery: "same",
      misc_income: "same",
      hire_charge: "same",
      hamali_charge: "same",
      unloading: "same",
      rto_charge: "same",
      office_mamul: "same",
      other_expense: "same",
      container_charge: "same",
      union_charge: "same",
      unloading_detension_charge: "same",
      incentive_charge: "same",
      extra_point_charge: "same",
      tds: "same",
      payment_type: "same",
      payment_type1: "same",
      payment_type2:"same",
      payment_type3:"same",
      payment_type4:"same",
      payment_type5:"same",
      other: "same",
      billing_party: "same",
      billing_party_name: "same",
      party_rate: "same",
      weight: "same",
      rate:"same",
      adv_bal: "same",
      charge_weight: "same",
      lorry_hire_weight: "same",
      advance_date: "same",
      grand_total_date: "same",
      broker_name: "same",
    },
    responseSchema: {
      booking_chalan_no: "challan_no",
      status: "same",
    },
    url:
      process.env.REACT_APP_CLIENT === "xpress"
      ? SERVER_URL + "/challan/save_chalan_trip/"
        : ["guru", "bgtc", "gdala_log","nrab", "vihira", "bbac", "jtsa", "bvtc"].includes(process.env.REACT_APP_CLIENT)
        ? SERVER_URL + "/challan/"
        : SERVER_URL + "/challan",
    methodType: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      if (!text.challan_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
    additionalFilterOnInput: (inputObject) => {
      if (inputObject.cewb_no == "") {
        inputObject.cewb_no = null;
      }
      if (inputObject.cewb_no2 == "") {
        inputObject.cewb_no2 = null;
      }
      if (inputObject.manual_no == "") {
        inputObject.manual_no = null;
      }
      for (let key in inputObject){
        if (inputObject[key] == "") {
          inputObject[key] = null;
        }
      }
      if (["bvtc"].includes(process.env.REACT_APP_CLIENT)) {
        if (inputObject.destination == null) {
          inputObject.destination = inputObject.station_to;
        }
        if (inputObject.destination_name == null) {
          inputObject.destination_name = inputObject.station_to_name;
        }
      }
      return inputObject;
    },
  },
  modifyChallan: {
    paramSchema: {
      receiver_name: "same",
      balance_paid: "same",
      balance_paid_date: "same",
      tds_date: "same",
      pan_no: "same",
      billing_party: "same",
      billing_party_name: "same",
      station_from: "same",
      station_to: "same",
      destination: "same",
      station_from_name: "same",
      station_to_name: "same",
      destination_name: "same",
      vehicle_id: "same",
      vehicle_no: "same",
      created_from: "same",
      remarks: "same",
      created_by: "same",
      bilty_ids: "bilty_nos",
      driver_name: "same",
      created_by_name: "same",
      owner_name: "same",
      challan_no: "booking_chalan_no",
      input_date: "booking_chalan_date",
      cewb_no: "same",
      cewb_no2: "same",
      phone_no: "same",
      manual_no: "same",
      company_id: "companyId",
      fYear_get: "fyear",
      transaction_id: "same",
      role_id: "same",
      is_crossing_challan: "same",
      lorry_hire: "same",
      loading: "same",
      detention: "same",
      total: "same",
      advance1: "same",
      advance2: "same",
      advance3:"same",
      advance4:"same",
      advance5:"same",
      diesel_amount: "same",
      commision: "same",
      balance_1: "same",
      balance_2: "same",
      petrol_pump_name: "same",
      diesel_quantity: "same",
      diesel_rate: "same",
      start_km: "same",
      less_deduction: "same",
      delivery_charge: "same",
      height_charge: "same",
      claim_charge: "same",
      late_delivery: "same",
      misc_income: "same",
      hire_charge: "same",
      hamali_charge: "same",
      unloading: "same",
      rto_charge: "same",
      office_mamul: "same",
      other_expense: "same",
      container_charge: "same",
      union_charge: "same",
      unloading_detension_charge: "same",
      incentive_charge: "same",
      extra_point_charge: "same",
      tds: "same",
      payment_type: "same",
      payment_type1: "same",
      payment_type2:"same",
      payment_type3:"same",
      payment_type4:"same",
      payment_type5:"same",
      other: "same",
      billing_party: "same",
      billing_party_name: "same",
      party_rate: "same",
      weight: "same",
      rate:"same",
      adv_bal: "same",
      charge_weight: "same",
      lorry_hire_weight: "same",
      advance_date: "same",
      grand_total_date: "same",
      broker_name: "same",
    },
    responseSchema: {
      booking_chalan_no: "challan_no",
      status: "same",
    },
    url: process.env.REACT_APP_CLIENT === "xpress" ? (SERVER_URL + "/challan/update_chalan_trip/") : (SERVER_URL + "/challan/"),
    methodType: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      if (!text.challan_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
    additionalFilterOnInput: (inputObject) => {
      console.log(inputObject);
      if (inputObject.transaction_id == "") {
        inputObject.transaction_id = null;
      }
      if (inputObject.cewb_no == "") {
        inputObject.cewb_no = null;
      }
      if (inputObject.cewb_no2 == "") {
        inputObject.cewb_no2 = null;
      }
      if (inputObject.manual_no == "") {
        inputObject.manual_no = null;
      }
      for (let key in inputObject){
        if (inputObject[key] == "") {
          inputObject[key] = null;
        }
      }
      if (["bvtc"].includes(process.env.REACT_APP_CLIENT)) {
        if (inputObject.destination == null) {
          inputObject.destination = inputObject.station_to;
        }
        if (inputObject.destination_name == null) {
          inputObject.destination_name = inputObject.station_to_name;
        }
      }
      return inputObject;
    },
  },
  getCitySuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/branch/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getVehicleSuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/vehicle/",
    methodType: "GET",
    respoonseSchema: {},
  },
};
const fleetApiConfig = {
  getFleet: {
    responseSchema: {
      total_final_amount: "same",
      trip_info: "same",
      vehicle_no: "same",
      vehicle_id: "same",
      driver_name: "same",
      start_km: "same",
      end_km: "same",
      depart_date: "same",
      arrive_date: "same",
      journey_avg: "same",
      journey_diesel: "same",
      journey_km: "same",
      fleet_date: "same",
    },
    url: SERVER_URL + "/fleet_master/",
    methodType: "GET",
    additionalFilterOnResponse: (inputObj) => {
      inputObj.total_final_amount = parseFloat(inputObj.total.total_amount);

      if (inputObj.total.balance_type == "dr") {
        inputObj.total_final_amount *= -1;
      }

      return inputObj;
    },
  },
  saveFleet: {
    paramSchema: {
      trip_info: "same",
      fleet_no: "same",
      vehicle_no: "same",
      vehicle_id: "same",
      driver_name: "same",
      start_km: "same",
      end_km: "same",
      depart_date: "same",
      arrive_date: "same",
      journey_avg: "same",
      journey_diesel: "same",
      journey_km: "same",
      fleet_date: "same",
      fleet_date: "same",
    },
    responseSchema: {
      fleet_no: "fleet_no",
    },
    url: SERVER_URL + "/fleet_master/",
    methodType: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      console.log(text);
      // We only throw the error if the incoming data status is not equal to "ok"
      if (!text.fleet_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
    additionalFilterOnInput: (inputObject) => {
      if (inputObject.fleet_no == "") {
        inputObject.fleet_no = null;
      }

      let tripInfo = inputObject.trip_info;

      tripInfo = tripInfo.map((entry) => {
        for (let key in entry) {
          if (entry[key] == "") {
            entry[key] = null;
          }
        }
        return entry;
      });

      inputObject.trip_info = tripInfo;

      console.log(inputObject);

      return inputObject;
    },
  },
  getCitySuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/branch/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getVehicleSuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/vehicle/",
    methodType: "GET",
    respoonseSchema: {},
  },
};
const stockOutwardApiConfig = {
  getStockOutward: {
    responseSchema: {
      type: "same",
      outward_type: "same",
      outward_date: "same",
      station_from: "same",
      station_from_name: "same",
      station_to: "same",
      station_to_name: "same",
      inwarded: "same",
      remark: "same",
      fyear: "same",
      receive_user: "same",
      item_info: "same",
      id: "same",
    },
    url: SERVER_URL + "/stock_register/",
    methodType: "GET",
    // additionalFilterOnResponse: (inputObj) => {
    //     inputObj.total_final_amount = parseFloat(inputObj.total.total_amount);

    //     if(inputObj.total.balance_type == "dr") {
    //         inputObj.total_final_amount *= -1;
    //     }

    //     return inputObj;
    // }
  },
  saveStockOutward: {
    paramSchema: {
      type: "same",
      outward_type: "same",
      outward_date: "same",
      station_from: "same",
      station_to: "same",
      inwarded: "same",
      remark: "same",
      receive_user: "same",
      item_info: "same",
      fYear: "fyear",
      company_id: "companyId",
    },
    responseSchema: {
      register_no: "register_no",
    },
    url: SERVER_URL + "/stock_register/",
    methodType: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    additionalFilterOnInput: (inputObject) => {
      let tmp = [
        "companyId",
        "inwarded",
        "outward_type",
        "station_from",
        "station_to",
        "type",
      ];

      for (let key in inputObject) {
        if (tmp.indexOf(key) > -1) {
          inputObject[key] = parseInt(inputObject[key]);
        }
      }

      return inputObject;
    },
    validateResponse: (text) => {
      console.log(text);
      // We only throw the error if the incoming data status is not equal to "ok"
      if (!text.register_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
  },
  editStockOutward: {
    paramSchema: {
      id: "same",
    },
    url: SERVER_URL + "/stock_register/inward",
    methodType: "POST",
  },
  getCitySuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/branch/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getVehicleSuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/vehicle/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getItemSuggestions: {
    url: SERVER_URL + "/item/",
    methodType: "POST",
    respoonseSchema: {},
    // tailTruncate: true,
  },
};
const stockInwardApiConfig = {
  getStockInward: {
    responseSchema: {
      type: "same",
      inward_date: "same",
      station_to: "same",
      station_to_name: "same",
      remark: "same",
      bill_no: "same",
      vendor: "same",
      payment_status: "same",
      item_info: "same",
      fyear: "same",
      id: "same",
    },
    url: SERVER_URL + "/stock_register/",
    methodType: "GET",
  },
  saveStockInward: {
    paramSchema: {
      type: "same",
      inward_date: "same",
      station_to: "same",
      remark: "same",
      fyear: "same",
      companyId: "same",
      bill_no: "same",
      vendor: "same",
      payment_status: "same",
      item_info: "same",
      fYear: "fyear",
      company_id: "companyId",
    },
    responseSchema: {
      register_no: "register_no",
    },
    url: SERVER_URL + "/stock_register/",
    methodType: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    additionalFilterOnInput: (inputObject) => {
      let tmp = ["station_to", "bill_no", "payment_Status", "type"];

      for (let key in inputObject) {
        if (tmp.indexOf(key) > -1) {
          inputObject[key] = parseInt(inputObject[key]);
        }
      }

      return inputObject;
    },
    validateResponse: (text) => {
      console.log(text);
      // We only throw the error if the incoming data status is not equal to "ok"
      if (!text.register_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
  },
  editStockOutward: {
    paramSchema: {
      id: "same",
    },
    url: SERVER_URL + "/stock_register/inward",
    methodType: "POST",
  },
  getCitySuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/branch/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getVehicleSuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/vehicle/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getItemSuggestions: {
    url: SERVER_URL + "/item/",
    methodType: "POST",
    respoonseSchema: {},
    // tailTruncate: true,
  },
};

const marfatiyaApiConfig = {
  getMarfatiya: {
    responseSchema: {
      station_name: "same",
      vehicle_id: "same",
      mf_id: "same",
      mf_no: "same",
      vehicle_no: "same",
      created_from: "same",
      remark: "same",
      created_by: "same",
      driver_name: "same",
      // amount: "same",
      is_deleted: "same",
      mf_date: "mf_date",
      party_name: "same",
      // silak: "same",
      fyear: "fYear_get",
      // left_pkgs: "same",
      bilty_package: "same",
      bilty_no: "same",
      companyId: "same",
      pkgs: "same",
      bilty_info: "same",
      remarks: "same",
      cewb_no: "same",
      total_tempo_collection: "same",
      status: "same",
      lorry_hire: "same",
    },
    additionalFilterOnResponse: (inputObject) => {
      console.log('marfatiyaRes', inputObject)
      if (inputObject.fYear_get) {
        inputObject.fyear = inputObject.fYear_get;
      }
      if (inputObject.mf_date && inputObject.mf_date.includes("T")) {
        let dateObj = new Date(inputObject.mf_date);
        inputObject.mf_date = dateObj.toString();
      }    
      return inputObject;

    },
    url: SERVER_URL + "/marfatiya/",
    methodType: "GET",
  },
  generateCwb: {
    responseSchema: {
      status: "same",
      cewb_no: "same",
    },
    url: SERVER_URL + "/ewb/consolidated/",
    methodType: "GET",
  },
  saveMarfatiya: {
    paramSchema: {
      station_name: "same",
      // station_to: "same",
      vehicle_no: "same",
      created_from: "same",
      remark: "same",
      created_by: "same",
      // amount: "same",
      mf_date: "same",
      fYear: "fyear",
      // silak: "same",
      // left_pkgs: "same",
      // total_pkgs: "same",
      party_name: "same",
      driver_name: "same",
      bilty_ids: "bilty_ids",
      pkgs: "same",
      company_id: "companyId",
      remarks: "same",
      cewb_no: "same",
      total_tempo_collection: "same",
      lorry_hire: "same",
    },
    responseSchema: {
      mf_no: "same",
      status: "same",
    },
    url: SERVER_URL + "/marfatiya/",
    methodType: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      if (!text.mf_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
    additionalFilterOnInput: (inputObject) => {
      console.log("12345678",inputObject);

      if ("companyId" in inputObject) {
        const convertedValue = Number(inputObject.companyId);
        inputObject.companyId = isNaN(convertedValue) ? inputObject.companyId : convertedValue;
      }

      // if ("bilty_ids" in inputObject && Array.isArray(inputObject.bilty_ids)) {
      //   inputObject.bilty_ids = inputObject.bilty_ids.map(bilty => bilty.bilty_id);
      // }

      if ("bilty_ids" in inputObject && Array.isArray(inputObject.bilty_ids)) {
        inputObject.bilty_ids = inputObject.bilty_ids.map(bilty => ({
          bilty_id: Number(bilty.bilty_id) || 0,
          packages: Number(
            bilty.packages ??
            bilty.no_of_package ??
            0
          ),
          // actual_packages: Number(bilty.actual_packages)
        }));
      }

      if (
        inputObject.lorry_hire === "" ||
        inputObject.lorry_hire === null ||
        inputObject.lorry_hire === undefined
      ) {
        inputObject.lorry_hire = 0;
      } else {
        inputObject.lorry_hire = Number(inputObject.lorry_hire);
      }

      return inputObject;
    },
  },
  modifyMarfatiya: {
    paramSchema: {
      mf_id: "same",
      mf_no: "same",
      station_name: "same",
      // station_to: "same",
      vehicle_no: "same",
      created_from: "same",
      remark: "same",
      created_by: "same",
      // amount: "same",
      mf_date: "same",
      fYear: "fyear",
      // silak: "same",
      // left_pkgs: "same",
      // total_pkgs: "same",
      party_name: "same",
      driver_name: "same",
      bilty_ids: "bilty_ids",
      pkgs: "same",
      company_id: "companyId",
      remarks: "same",
      cewb_no: "same",
      total_tempo_collection: "same",
      lorry_hire: "same",
    },
    responseSchema: {
      mf_no: "same",
      status: "same",
    },
    url: SERVER_URL + "/marfatiya/",
    methodType: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      if (!text.mf_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
    additionalFilterOnInput: (inputObject) => {
      console.log("12345678",inputObject);

      if ("companyId" in inputObject) {
        const convertedValue = Number(inputObject.companyId);
        inputObject.companyId = isNaN(convertedValue) ? inputObject.companyId : convertedValue;
      }

      if ("bilty_ids" in inputObject && Array.isArray(inputObject.bilty_ids)) {
        inputObject.bilty_ids = inputObject.bilty_ids.map(bilty => ({
          bilty_id: Number(bilty.bilty_id) || 0,
          packages: Number(
            bilty.packages ??
            bilty.no_of_package ??
            0
          ),
        }));
      }

      if ("mf_date" in inputObject && inputObject.mf_date) {
        const date = new Date(inputObject.mf_date);
        if (!isNaN(date.getTime())) {
          inputObject.mf_date = date.toISOString().slice(0, 16);
        }
      }

      if (
        inputObject.lorry_hire === "" ||
        inputObject.lorry_hire === null ||
        inputObject.lorry_hire === undefined
      ) {
        inputObject.lorry_hire = 0;
      } else {
        inputObject.lorry_hire = Number(inputObject.lorry_hire);
      }

      return inputObject;
    },
  },
  
  getCitySuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/branch/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getVehicleSuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/vehicle/trip/",
    methodType: "GET",
    respoonseSchema: {},
  },
};

const separateEwbApiConfig = {
  getChallan: {
    responseSchema: {
      booking_chalan_no: "challan_no",
      station_from: "same",
      station_to: "same",
      destination: "same",
      station_from_name: "same",
      station_to_name: "same",
      destination_name: "same",
      vehicle_id: "same",
      vehicle_no: "same",
      created_from: "same",
      license_no: "same",
      remarks: "same",
      created_by: "same",
      bilty_info: "bilty_ids",
      driver_name: "same",
      owner_name: "same",
      status: "same",
      is_deleted: "same",
      phone_no: "same",
      bilty_no: "",
      No: "",
      booking_chalan_date: "input_date",
      cewb_no: "same",
      is_inwarded: "same",
      manual_no: "same",
      trip_no: "same",
      fyear: "same",
    },
    url: SERVER_URL + "/separate-ewb/",
    methodType: "GET",
  },
  getManualChallan: {
    responseSchema: {
      station_from: "same",
      station_to: "same",
      destination: "same",
      station_from_name: "same",
      station_to_name: "same",
      destination_name: "same",
      vehicle_id: "same",
      vehicle_no: "same",
      created_from: "same",
      license_no: "same",
      remarks: "same",
      created_by: "same",
      bilty_info: "bilty_ids",
      driver_name: "same",
      owner_name: "same",
      status: "same",
      is_deleted: "same",
      phone_no: "same",
      bilty_no: "",
      booking_chalan_no: "challan_no",
      booking_chalan_date: "input_date",
      cewb_no: "same",
      is_inwarded: "same",
      multiple_manual_chalan: "same",
    },
    url: SERVER_URL + "/challan/manual/",
    methodType: "GET",
  },
  generateCwb: {
    responseSchema: {
      status: "same",
      cewb_no: "same",
    },
    url: SERVER_URL + "/ewb/consolidated/separate/",
    methodType: "GET",
  },
  saveChallan: {
    paramSchema: {
      challan_no: "booking_chalan_no",
      station_from: "station_from",
      station_to: "station_to",
      vehicle_no: "vehicle_no",
      created_from: "created_from",
      driver_name: "driver_name",
      phone_no: "phone_no",
      remarks: "remarks",
      cewb_no: "cewb_no",
      is_inwarded: "is_inwarded",
      input_date: "booking_chalan_date",
      created_by: "created_by",
      status: "status",
      bilty_ids: "bilty_nos",
      fYear: "fyear",
      company_id: "companyId",
    },
    responseSchema: {
      booking_chalan_no: "challan_no",
      status: "same",
    },
    url: SERVER_URL + "/separate-ewb/",
    methodType: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      if (!text.challan_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
    additionalFilterOnInput: (inputObject) => {
      // console.log("III", inputObject.booking_chalan_no);
      if (inputObject.booking_chalan_no == "") {
        inputObject.booking_chalan_no = null;
      }
      if (inputObject.cewb_no == "") {
        inputObject.cewb_no = null;
      }
      if (inputObject.is_inwarded == "") {
        inputObject.is_inwarded = "0";
      }
      if (inputObject.status == "") {
        inputObject.status = "1";
      }
      return inputObject;
    },
  },
  modifyChallan: {
    paramSchema: {
      challan_no: "booking_chalan_no",
      station_from: "station_from",
      station_to: "station_to",
      vehicle_no: "vehicle_no",
      created_from: "created_from",
      driver_name: "driver_name",
      phone_no: "phone_no",
      remarks: "remarks",
      cewb_no: "cewb_no",
      is_inwarded: "is_inwarded",
      input_date: "booking_chalan_date",
      created_by: "created_by",
      status: "status",
      bilty_ids: "bilty_nos",
      fYear: "fyear",
      company_id: "companyId",
    },
    responseSchema: {
      booking_chalan_no: "challan_no",
      status: "same",
    },
    url: SERVER_URL + "/separate-ewb/",
    methodType: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      if (!text.challan_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
    additionalFilterOnInput: (inputObject) => {
      // console.log("III", inputObject.booking_chalan_no);
      if (inputObject.booking_chalan_no == "") {
        inputObject.booking_chalan_no = null;
      }
      if (inputObject.cewb_no == "") {
        inputObject.cewb_no = null;
      }
      if (inputObject.is_inwarded == "") {
        inputObject.is_inwarded = "0";
      }
      if (inputObject.status == "") {
        inputObject.status = "1";
      }
      return inputObject;
    },
  },
  getCitySuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/branch/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getVehicleSuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/vehicle/",
    methodType: "GET",
    respoonseSchema: {},
  },
};

const accountTransactionApiConfig = {
  getPage: {
    responseSchema: {
      account_transaction_info: "same",
      input_date: "same",
      total_amount: "same",
      fyear: "fYear_get",
    },
    url: SERVER_URL + "/account_trans/",
    methodType: "GET",
    additionalFilterOnResponse: (inputObject) => {
      let newList = [];
      let dummyObject = {};
      let outputObj = {};
      // inputObject.reverse()
      for (let i = 0; i < inputObject.length; i++) {
        if (i % 2 == 0) {
          dummyObject = {};
          console.log("Input o", inputObject[i]);
          console.log("input i", inputObject[i + 1]);
          dummyObject.voucher_type = inputObject[i].voucher_type;
          (dummyObject.consignor_id = inputObject[i].party_id),
            (dummyObject.consignor_name = inputObject[i].party_name);
          dummyObject.amount = inputObject[i].debit;
          dummyObject.consignee_id = inputObject[i + 1].party_id;
          dummyObject.consignee_name = inputObject[i + 1].party_name;
          dummyObject.remarks = inputObject[i].remarks;
          dummyObject.cheque_no = inputObject[i].cheque_no;
          dummyObject.bank_name = inputObject[i].bank_name;
          dummyObject.unique_id = inputObject[i].unique_id;
          dummyObject.voucher_id = inputObject[i].voucher_id;
          dummyObject.created_from = inputObject[i].created_from;
          dummyObject.vehicle_no = inputObject[i].vehicle_no;
          dummyObject.created_by = inputObject[i].created_by;
          dummyObject.account_id = inputObject[i].account_id;
          dummyObject.date = inputObject[i].date;
          if(process.env.REACT_APP_CLIENT == "xpress") {
            dummyObject.balance = inputObject[i].balance;
            dummyObject.clearance_status = inputObject[i].clearance_status;
            dummyObject.id = inputObject[i].id;
            dummyObject.balance_type = inputObject[i].balance_type;
            dummyObject.party_name = inputObject[i].party_name;
            dummyObject.created_from_name = inputObject[i].created_from_name;
            dummyObject.created_by_name = inputObject[i].created_by_name;
            dummyObject.module = inputObject[i].module;
            dummyObject.module_no = inputObject[i].module_no;
            dummyObject.voucher_no = inputObject[i].voucher_no;
            dummyObject.account_relation_voucher_type = inputObject[i].account_relation_voucher_type;
            dummyObject.account_relation_id = inputObject[i].account_relation_id;
            dummyObject.charge = inputObject[i].charge;
          dummyObject.account_transaction_id = inputObject[i].account_transaction_id;
          dummyObject.modified_date = inputObject[i].modified_date;
          dummyObject.clearance_date = inputObject[i].clearance_date;
          dummyObject.created_date = inputObject[i].created_date;
        }
          dummyObject.clearance_status =
            inputObject[i].clearance_status ??
            inputObject[i + 1].clearance_status;
          dummyObject.clearance_date =
            inputObject[i].clearance_date ?? inputObject[i + 1].clearance_date;
          newList.push(dummyObject);
        }
      }
      outputObj.account_transaction_info = newList;
      outputObj.input_date = outputObj.account_transaction_info[0].date;
      let total_amount = 0;
      for (let i = 0; i < outputObj.account_transaction_info.length; i++) {
        total_amount += outputObj.account_transaction_info[i].amount;
      }
      outputObj.total_amount = total_amount.toFixed(2);
      console.log("Out onbjk", outputObj);
      return outputObj;
    },
  },
  savePage: {
    paramSchema: {
      account_transaction_info: "same",
      input_date: "same",
      company_id: "companyId",
      fYear: "fyear",
    },
    responseSchema: {
      status: "same",
      voucher_id: "id",
    },
    url: SERVER_URL + "/account_trans/",
    methodType: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    // validateResponse: (text) => {
    //   // We only throw the error if the incoming data status is not equal to "ok"
    //   if (!text.challan_no) {
    //     console.log("In fff");
    //     throw new Error("The required value must be a number fff");
    //   }
    // },
    reverseArr: (input) => {
      var ret = new Array();
      for (var i = input.length - 1; i >= 0; i--) {
        ret.push(input[i]);
      }
      return ret;
    },
    additionalFilterOnInput: (inputObject) => {
      let listToSend = [];
      let newObj = {};
      let objToProcess = {};
      let outputObj = {};
      // inputObject = reverseArr(inputObject)
      var ret = new Array();
      for (let i = 0; i < inputObject.account_transaction_info.length; i++) {
        inputObject.account_transaction_info[i].date = new Date(
          inputObject.input_date
        ).toISOString();
        ret.push(inputObject.account_transaction_info[i]);
      }
      inputObject.account_transaction_info = ret;
      for (let i = 0; i < inputObject.account_transaction_info.length; i++) {
        objToProcess = inputObject.account_transaction_info[i];
        console.log("ob 2 pr", objToProcess);
        newObj = {};
        newObj.voucher_type = objToProcess.voucher_type;
        (newObj.cheque_no = objToProcess.cheque_no),
          (newObj.bank_name = objToProcess.bank_name),
          (newObj.remarks = objToProcess.remarks),
          (newObj.created_from = objToProcess.created_from),
          (newObj.created_by = objToProcess.created_by),
          (newObj.date = objToProcess.date);
        newObj.credit = 0;
        newObj.debit = parseFloat(objToProcess.amount);
        newObj.party_id = objToProcess.consignor_id;
        newObj.voucher_id = objToProcess.voucher_id;
        newObj.unique_id = objToProcess.unique_id;
        newObj.created_from = objToProcess.created_from;
        newObj.created_by = objToProcess.created_by;
        newObj.other_party_id = objToProcess.consignee_id;
        newObj.vehicle_no = objToProcess.vehicle_no;
        newObj.account_id = objToProcess.account_id;
        newObj.date = objToProcess.date;
        newObj.companyId = inputObject.companyId;
        newObj.fyear = inputObject.fyear;
          if(process.env.REACT_APP_CLIENT == "xpress") {
            newObj.balance = objToProcess.balance;
        newObj.clearance_status = objToProcess.clearance_status;
        newObj.id = objToProcess.id;
        newObj.balance_type = objToProcess.balance_type;
        newObj.party_name = objToProcess.party_name;
        newObj.created_from_name = objToProcess.created_from_name;
        newObj.created_by_name = objToProcess.created_by_name;
        newObj.module = objToProcess.module;
        newObj.module_no = objToProcess.module_no;
        newObj.voucher_no = objToProcess.voucher_no;
        newObj.account_relation_voucher_type = objToProcess.account_relation_voucher_type;
        newObj.account_relation_id = objToProcess.account_relation_id;
        newObj.charge = objToProcess.charge;
        newObj.account_transaction_id = objToProcess.account_transaction_id;
        newObj.modified_date = objToProcess.modified_date;
        newObj.clearance_date = objToProcess.clearance_date;
        newObj.created_date = objToProcess.created_date;
          }
        if (objToProcess.voucher_type == "br") {
          newObj.clearance_status = objToProcess.clearance_status;
          newObj.clearance_date = objToProcess.clearance_date;
        }

        listToSend.push(newObj);

        newObj = {};
        newObj.voucher_type = objToProcess.voucher_type;
        (newObj.cheque_no = objToProcess.cheque_no),
          (newObj.bank_name = objToProcess.bank_name),
          (newObj.remarks = objToProcess.remarks),
          (newObj.created_from = objToProcess.created_from),
          (newObj.created_by = objToProcess.created_by),
          (newObj.date = objToProcess.date);
        newObj.debit = 0;
        newObj.credit = parseFloat(objToProcess.amount);
        newObj.party_id = objToProcess.consignee_id;
        newObj.voucher_id = objToProcess.voucher_id;
        newObj.unique_id = objToProcess.unique_id;
        newObj.created_from = objToProcess.created_from;
        newObj.created_by = objToProcess.created_by;
        newObj.other_party_id = objToProcess.consignor_id;
        newObj.vehicle_no = objToProcess.vehicle_no;
        newObj.account_id = objToProcess.account_id;
        newObj.date = objToProcess.date;
        newObj.companyId = inputObject.companyId;
        newObj.fyear = inputObject.fyear;
        newObj.balance = objToProcess.balance;
        newObj.clearance_status = objToProcess.clearance_status;
        newObj.id = objToProcess.id;
          if(process.env.REACT_APP_CLIENT == "xpress") {
            newObj.balance_type = objToProcess.balance_type;
        newObj.party_name = objToProcess.party_name;
        newObj.created_from_name = objToProcess.created_from_name;
        newObj.created_by_name = objToProcess.created_by_name;
        newObj.module = objToProcess.module;
        newObj.module_no = objToProcess.module_no;
        newObj.voucher_no = objToProcess.voucher_no;
        newObj.account_relation_voucher_type = objToProcess.account_relation_voucher_type;
        newObj.account_relation_id = objToProcess.account_relation_id;
        newObj.charge = objToProcess.charge;
        newObj.account_transaction_id = objToProcess.account_transaction_id;
        newObj.modified_date = objToProcess.modified_date;
        newObj.clearance_date = objToProcess.clearance_date;
        newObj.created_date = objToProcess.created_date;
          }
          if (objToProcess.voucher_type == "bp") {
          newObj.clearance_status = objToProcess.clearance_status;
          newObj.clearance_date = objToProcess.clearance_date;
        }
        console.log("Inner", newObj);
        listToSend.push(newObj);
        console.log("Inner List", listToSend);
      }
      console.log("laslds", listToSend);
      outputObj.account_transaction_info = listToSend;
      console.log("!!!!!!!!!!!!!!!!", inputObject);
      return outputObj;
    },
  },
  modifyPage: {
    paramSchema: {
      station_from: "same",
      station_to: "same",
      destination: "same",
      station_from_name: "same",
      station_to_name: "same",
      destination_name: "same",
      vehicle_id: "same",
      vehicle_no: "same",
      created_from: "same",
      remarks: "same",
      created_by: "same",
      bilty_ids: "bilty_nos",
      driver_name: "same",
      owner_name: "same",
      challan_no: "booking_chalan_no",
      input_date: "booking_chalan_date",
      cewb_no: "same",
      company_id: "companyId",
      fYear_get: "fyear",
    },
    responseSchema: {
      booking_chalan_no: "challan_no",
      status: "same",
    },
    url: SERVER_URL + "/challan/",
    methodType: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      if (!text.challan_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
    additionalFilterOnInput: (inputObject) => {
      if (inputObject.cewb_no == "") {
        inputObject.cewb_no = null;
      }
      return inputObject;
    },
  },
  getVehicleSuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/vehicle/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getConsignorSuggestions: {
    url: SERVER_URL + "/consignor/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getNarrationSuggestions: {
    url: SERVER_URL + "/narration/filter/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getConsigneeSuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/consignee/",
    methodType: "GET",
    respoonseSchema: {},
  },
};

const BrokerageSummaryApiConfig = {
  getCitySuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/branch/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getConsignorSuggestions: {
    url: SERVER_URL + "/consignor/",
    methodType: "GET",
    respoonseSchema: {},
  },
};
const analysisReportApiConfig = {
  getCitySuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/branch/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getConsignorSuggestions: {
    url: SERVER_URL + "/consignor/",
    methodType: "GET",
    respoonseSchema: {},
  },
};

const podChallanApiConfig = {
  getChallan: {
    responseSchema: {
      id: "same",
      station_from: "same",
      station_to: "same",
      destination: "same",
      station_from_name: "same",
      station_to_name: "same",
      destination_name: "same",
      vehicle_id: "same",
      vehicle_no: "same",
      created_from: "same",
      remarks: "same",
      created_by: "same",
      bilty_ids: "same",
      driver_name: "same",
      owner_name: "same",
      status: "same",
      is_deleted: "same",
      pod_date: "input_date",
      is_inwarded: "same",
      fyear: "fYear_get",
    },
    url: SERVER_URL + "/pod/",
    methodType: "GET",
  },
  generateCwb: {
    responseSchema: {
      status: "same",
      cewb_no: "same",
    },
    url: SERVER_URL + "/ewb/consolidated/",
    methodType: "GET",
  },
  saveChallan: {
    paramSchema: {
      // pod_challan_date: "same",
      created_from: "same",
      station_to: "same",
      remarks: "same",
      created_by: "same",
      bilty_ids: "same",
      input_date: "pod_date",
      company_id: "companyId",
      fYear: "fyear",
      // pod_date: "booking_chalan_date",
    },
    responseSchema: {
      pod_no: "pod_challan_no",
      status: "same",
    },
    url: SERVER_URL + "/pod/",
    methodType: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      // if (!text.pod_challan_no) {
      //   console.log("In fff");
      //   throw new Error("The required value must be a number fff");
      // }
    },
    // additionalFilterOnInput: (inputObject) => {
    //     if (inputObject.eway_bill_info &&
    //         inputObject.eway_bill_info.length==1 &&
    //         inputObject.eway_bill_info[0].eway_bill_no == ""){
    //         delete inputObject.eway_bill_info
    //     }
    //     return inputObject;
    // },
  },
  modifyChallan: {
    paramSchema: {
      id: "same",
      created_from: "same",
      station_to: "same",
      remarks: "same",
      created_by: "same",
      bilty_ids: "same",
      input_date: "pod_date",
      pod_challan_no: "pod_no",
      company_id: "companyId",
      fYear_get: "fyear",
    },
    responseSchema: {
      booking_chalan_no: "pod_challan_no",
      status: "same",
    },
    url: SERVER_URL + "/pod/",
    methodType: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
    },
    // additionalFilterOnInput: (inputObject) => {
    //     if (inputObject.eway_bill_info &&
    //         inputObject.eway_bill_info.length==1 &&
    //         inputObject.eway_bill_info[0].eway_bill_no == ""){
    //         delete inputObject.eway_bill_info
    //     }
    //     return inputObject;
    // },
  },
  getCitySuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/branch/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getVehicleSuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/vehicle/",
    methodType: "GET",
    respoonseSchema: {},
  },
};

const mrInquiryApiConfig = {
  getMrInquiry: {
    responseSchema: {
      pf_amount: "same",
      hamali: "same",
      delivery_on: "same",
      service_charge: "same",
      demarage_charge: "same",
      other_charge: "same",
      payment_type: "same",
      cheque_no: "same",
      total_amount: "same",
      marfatiya: "same",
      party_name: "same",
      receiver_name: "same",
      lorry_rate: "same",
      bilty_info: "bilty_ids",
      created_from: "same",
      remarks: "same",
      refund: "same",
      mr_date: "input_date",
      created_by: "same",
      is_deleted: "same",
      to_pay_amount: "same",
      fyear: "fYear_get",
    },
    url: SERVER_URL + "/money_receipt/",
    methodType: "GET",
  },
};

const mrApiConfig = {
  getMr: {
    responseSchema: {
      mr_id: "same",
      pf_amount: "pf",
      hamali: "same",
      delivery_on: "same",
      service_charge: "same",
      demarage_charge: "same",
      other_charge: "same",
      payment_type: "same",
      cheque_no: "same",
      total_amount: "same",
      marfatiya: "same",
      // marfatiya_id: "same",
      party_name: "same",
      receiver_name: "same",
      lorry_rate: "same",
      bilty_info: "bilty_ids",
      created_from: "same",
      account_name: "same",
      account_id: "same",
      remarks: "same",
      refund: "same",
      created_by: "same",
      is_deleted: "same",
      to_pay_amount: "same",
      mr_date: "input_date",
      fyear: "fYear_get",
    },
    url: SERVER_URL + "/money_receipt/",
    methodType: "GET",
  },
  saveMr: {
    paramSchema: {
      pf:"pf_amount",
      role_id:"same",
      hamali: "same",
      delivery_on: "same",
      service_charge: "same",
      demarage_charge: "same",
      other_charge: "same",
      payment_type: "same",
      cheque_no: "same",
      total_amount: "same",
      marfatiya: "same",
      // marfatiya_id: "same",
      party_name: "same",
      receiver_name: "same",
      account_name: "same",
      account_id: "same",
      lorry_rate: "same",
      bilty_ids: "bilty_nos",
      created_from: "same",
      remarks: "same",
      refund: "same",
      created_by: "same",
      to_pay_amount: "same",
      input_date: "mr_date",
      company_id: "companyId",
      fYear: "fyear",
    },
    responseSchema: {
      mr_no: "same",
      mr_id: "same",
    },
    url: SERVER_URL + "/money_receipt/",
    methodType: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      if (!text.mr_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
    additionalFilterOnInput: additionalFilterOnInputForMr,
    // additionalFilterOnInput: (inputObject) => {
    //     if (inputObject.eway_bill_info &&
    //         inputObject.eway_bill_info.length==1 &&
    //         inputObject.eway_bill_info[0].eway_bill_no == ""){
    //         delete inputObject.eway_bill_info
    //     }
    //     return inputObject;
    // },
  },
  modifyMr: {
    paramSchema: {
      pf:"pf_amount",
      role_id:"same",
      mr_no: "same",
      hamali: "same",
      delivery_on: "same",
      service_charge: "same",
      demarage_charge: "same",
      other_charge: "same",
      payment_type: "same",
      cheque_no: "same",
      account_name: "same",
      account_id: "same",
      total_amount: "same",
      marfatiya: "same",
      // marfatiya_id: "same",
      party_name: "same",
      receiver_name: "same",
      lorry_rate: "same",
      bilty_ids: "bilty_nos",
      created_from: "same",
      remarks: "same",
      refund: "same",
      created_by: "same",
      to_pay_amount: "same",
      input_date: "mr_date",
      company_id: "companyId",
      fYear_get: "fyear",
    },
    responseSchema: {
      mr_no: "same",
      mr_id: "same",
    },
    url: SERVER_URL + "/money_receipt/",
    methodType: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      if (!text.mr_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
    additionalFilterOnInput: additionalFilterOnInputForMr,
    // additionalFilterOnInput: (inputObject) => {
    //     if (inputObject.eway_bill_info &&
    //         inputObject.eway_bill_info.length==1 &&
    //         inputObject.eway_bill_info[0].eway_bill_no == ""){
    //         delete inputObject.eway_bill_info
    //     }
    //     return inputObject;
    // },
  }, 
  getTransporterSuggestions: {
    url: SERVER_URL + "/transporter/",
    methodType: "POST",
    respoonseSchema: {},
  },
  getConsigneeSuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/consignee/",
    methodType: "GET",
    respoonseSchema: {},
  },
};

const tripApiConfig = {
  getTrip: {
    responseSchema: {
      payment_1: "same",
      payment_date_1: "same",
      payment_2: "same",
      payment_type_2: "same",
      payment_date_2: "same",
      balance: "same",
      loaded_by: "same",
      license_no: "same",
      onwer_no: "same",
      driver_no: "same",
      other_charge: "same",
      labour: "same",
      extra_charge: "same",
      detention_charge: "same",
      shortage_charge: "same",
      other_deduction_charge: "same",
      pan_no: "same",
      billing_party: "same",
      billing_party_name: "same",
      station_from: "same",
      station_to: "same",
      destination: "same",
      station_from_name: "same",
      station_to_name: "same",
      destination_name: "same",
      vehicle_id: "same",
      vehicle_no: "same",
      created_from: "same",
      remarks: "same",
      created_by: "same",
      booking_chalan_info: "challan_ids",
      driver_name: "same",
      owner_name: "same",
      status: "same",
      amount: "same",
      is_deleted: "same",
      trip_date: "input_date",
      advance_bhada: "same",
      balance_bhada: "balance_bhada",
      payable_branch: "same",
      payable_branch_name: "same",
      receiver_name: "same",
      bhada_remarks: "same",
      payment_type: "same",
      is_bhada_paid: "same",
      module_trip_bhada: "same",
      bhada_paid_date: "same",
      id: "same",
      bhada_paid_branch_name: "same",
      fyear: "fYear_get",
      bhada_paid_branch: "same",
      tds_amount: "same",
      net_balance: "same",
      tds_rate: "same",
      payable_declaration: "same",
      total_pkg:"same",
      driver_license_no: "same",
      policy_no: "same",
      chasis_no: "same",
      engine_no: "same",
      insurance_company: "same",
      permit_no: "same",
      pan_no: "same",
      broker_name: "same",
      driver_phone_no: "same",
    },
    additionalFilterOnResponse: (inputObject) => {
      try {
        if (
          "bhada_paid_date" in inputObject &&
          inputObject.bhada_paid_date == null
        ) {
          console.log("In adfsd");
          //   inputObject.bhada_paid_date = new Date()
        }
        console.log("Hewrereref", inputObject);
        return inputObject;
      } catch {
        console.log("Herer");
        return inputObject;
      }
    },
    url: SERVER_URL + "/trip/",
    methodType: "GET",
  },
  generateCwb: {
    responseSchema: {
      status: "same",
      cewb_no: "same",
    },
    url: SERVER_URL + "/ewb/consolidated/",
    methodType: "GET",
  },
  saveTrip: {
    paramSchema: {
      payment_1: "same",
      payment_date_1: "same",
      payment_2: "same",
      payment_type_2: "same",
      payment_date_2: "same",
      balance: "same",
      loaded_by: "same",
      license_no: "same",
      onwer_no: "same",
      driver_no: "same",
      other_charge: "same",
      labour: "same",
      extra_charge: "same",
      detention_charge: "same",
      shortage_charge: "same",
      other_deduction_charge: "same",
      pan_no: "same",
      billing_party: "same",
      billing_party_name: "same",
      station_from: "same",
      station_to: "same",
      vehicle_id: "same",
      created_from: "same",
      remarks: "same",
      created_by: "same",
      challan_ids: "booking_challan_info",
      amount: "same",
      input_date: "trip_date",
      advance_bhada: "same",
      balance_bhada: "same",
      payable_branch: "same",
      receiver_name: "same",
      bhada_remarks: "same",
      payment_type: "same",
      is_bhada_paid: "same",
      module_trip_bhada: "same",
      bhada_paid_date: "same",
      login_user_id: "modified_by",
      company_id: "companyId",
      fYear: "fyear",
      tds_amount: "same",
      net_balance: "same",
      total_pkg:"same",
      driver_license_no: "same",
      policy_no: "same",
      chasis_no: "same",
      engine_no: "same",
      insurance_company: "same",
      permit_no: "same",
      pan_no: "same",
      broker_name: "same",
      driver_phone_no: "same",
    },
    responseSchema: {
      trip_no: "same",
      status: "same",
    },
    url: SERVER_URL + "/trip/",
    methodType: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      if (!text.trip_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
    additionalFilterOnInput: (inputObject) => {
      console.log("12345678", inputObject);
      if ("module_trip_bhada" in inputObject && inputObject.module_trip_bhada) {
        inputObject.is_bhada_paid = true;
      }
      if("driver_no" in inputObject && inputObject.driver_no == "") {
        inputObject.driver_no = null
      }
      if("owner_no" in inputObject && inputObject.owner_no == "") {
        inputObject.owner_no = null
      }
      if("labour" in inputObject && inputObject.labour == "") {
        inputObject.labour = null
      }
      if("other_charge" in inputObject && inputObject.other_charge == "") {
        inputObject.other_charge = null
      }
      if("total_pkg" in inputObject && inputObject.total_pkg == "") {
        inputObject.total_pkg = null
      }
      return inputObject;
    },
  },
  modifyTrip: {
    paramSchema: {
      payment_1: "same",
      payment_date_1: "same",
      payment_2: "same",
      payment_type_2: "same",
      payment_date_2: "same",
      balance: "same",
      loaded_by: "same",
      license_no: "same",
      onwer_no: "same",
      driver_no: "same",
      other_charge: "same",
      labour: "same",
      extra_charge: "same",
      detention_charge: "same",
      shortage_charge: "same",
      other_deduction_charge: "same",
      pan_no: "same",
      billing_party: "same",
      billing_party_name: "same",
      station_from: "same",
      station_to: "same",
      vehicle_id: "same",
      created_from: "same",
      remarks: "same",
      created_by: "same",
      challan_ids: "booking_challan_info",
      amount: "same",
      trip_no: "same",
      input_date: "trip_date",
      advance_bhada: "same",
      balance_bhada: "same",
      payable_branch: "same",
      receiver_name: "same",
      bhada_remarks: "same",
      payment_type: "same",
      is_bhada_paid: "same",
      module_trip_bhada: "same",
      bhada_paid_date: "same",
      id: "same",
      login_user_id: "modified_by",
      // bhada_paid_branch:"created_from"
      //   bhada_paid_branch:"paid_branch",
      company_id: "companyId",
      fYear_get: "fyear",
      bhada_paid_branch: "same",
      tds_amount: "same",
      net_balance: "same",
      total_pkg:"same",
      driver_license_no: "same",
      policy_no: "same",
      chasis_no: "same",
      engine_no: "same",
      insurance_company: "same",
      permit_no: "same",
      pan_no: "same",
      broker_name: "same",
      driver_phone_no: "same",
    },
    responseSchema: {
      trip_no: "same",
      status: "same",
    },
    url: SERVER_URL + "/trip/",
    methodType: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      if (!text.trip_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
    additionalFilterOnInput: (inputObject) => {
      if ("bhada_paid_date" in inputObject && inputObject.bhada_paid_date == "") {
        inputObject.bhada_paid_date = null;
      }
      if ("bhada_paid_branch" in inputObject && inputObject.bhada_paid_branch == "") {
        inputObject.bhada_paid_branch = null;
      }
      if("driver_no" in inputObject && inputObject.driver_no == "") {
        inputObject.driver_no = null
      }
      if("owner_no" in inputObject && inputObject.owner_no == "") {
        inputObject.owner_no = null
      }
      if("labour" in inputObject && inputObject.labour == "") {
        inputObject.labour = null
      }
      if("other_charge" in inputObject && inputObject.other_charge == "") {
        inputObject.other_charge = null
      }
      if ("module_trip_bhada" in inputObject && inputObject.module_trip_bhada) {
        inputObject.is_bhada_paid = true;
        inputObject.bhada_paid_branch = JSON.parse(sessionStorage.branch_id).branch_id;
      }
      if ("balance" in inputObject && inputObject.balance == "") {
        inputObject.balance = 0; 
      }
      if ("payment_1" in inputObject && inputObject.payment_1 == "") {
        inputObject.payment_1 = 0; 
      }
      if ("payment_2" in inputObject && inputObject.payment_2 == "") {
        inputObject.payment_2 = 0;
      }
      if("total_pkg" in inputObject && inputObject.total_pkg == "") {
        inputObject.total_pkg = null
      }
      return inputObject;
    },
  },
  modifyTripBhada: {
    paramSchema: {
      payment_1: "same",
      payment_date_1: "same",
      payment_2: "same",
      payment_type_2: "same",
      payment_date_2: "same",
      balance: "same",
      loaded_by: "same",
      license_no: "same",
      onwer_no: "same",
      driver_no: "same",
      other_charge: "same",
      labour: "same",
      pan_no: "same",
      billing_party: "same",
      billing_party_name: "same",
      station_from: "same",
      station_to: "same",
      vehicle_id: "same",
      created_from: "same",
      remarks: "same",
      created_by: "same",
      challan_ids: "booking_challan_info",
      amount: "same",
      trip_no: "same",
      input_date: "trip_date",
      advance_bhada: "same",
      balance_bhada: "same",
      payable_branch: "same",
      receiver_name: "same",
      bhada_remarks: "same",
      payment_type: "same",
      is_bhada_paid: "same",
      module_trip_bhada: "same",
      bhada_paid_date: "same",
      id: "same",
      login_user_id: "modified_by",
      // bhada_paid_branch:"created_from"
      //   bhada_paid_branch:"paid_branch",
      company_id: "companyId",
      fYear_get: "fyear",
      bhada_paid_branch: "same",
      tds_amount: "same",
      net_balance: "same",
      payable_declaration: "same",
    },
    responseSchema: {
      trip_no: "same",
      status: "same",
    },
    url: SERVER_URL + "/trip/payable_save",
    methodType: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      if (!text.trip_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
    additionalFilterOnInput: (inputObject) => {
      console.log("12345678 modify trip", inputObject);
      inputObject.payable_declaration = parseInt(
        inputObject.payable_declaration
      );
      if (inputObject.modified_by != "1" && inputObject.modified_by != "220") {
        inputObject.payable_declaration = parseInt("-1");
      }
      if (
        "bhada_paid_date" in inputObject &&
        inputObject.bhada_paid_date == ""
      ) {
        inputObject.bhada_paid_date = null;
      }
      if (
        "tds_amount" in inputObject &&
        inputObject.tds_amount == ""
      ) {
        inputObject.tds_amount = 0;
      }
      if (
        "bhada_paid_branch" in inputObject &&
        inputObject.bhada_paid_branch == ""
      ) {
        inputObject.bhada_paid_branch = null;
      }
      if (
        "payment_2" in inputObject &&
        inputObject.payment_2 == ""
      ) {
        inputObject.payment_2 = parseInt(0);
      }
      if ("module_trip_bhada" in inputObject && inputObject.module_trip_bhada) {
        if(process.env.REACT_APP_CLIENT == "guru") {
          if("balance" in inputObject && inputObject.balance == 0){
            inputObject.is_bhada_paid = true
          }
        } else {
          inputObject.is_bhada_paid = true
        }
        inputObject.bhada_paid_branch = JSON.parse(
          sessionStorage.branch_id
        ).branch_id;
      }
      return inputObject;
    },
  },
  getCitySuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/branch/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getVehicleSuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/vehicle/trip/",
    methodType: "GET",
    respoonseSchema: {},
  },
};

const tripExtendedApiConfig = {
  getTrip: {
    responseSchema: {
      station_from: "same",
      station_to: "same",
      destination: "same",
      station_from_name: "same",
      station_to_name: "same",
      destination_name: "same",
      vehicle_id: "same",
      vehicle_no: "same",
      created_from: "same",
      remarks: "same",
      created_by: "same",
      booking_chalan_info: "challan_ids",
      driver_name: "same",
      owner_name: "same",
      status: "same",
      amount: "same",
      is_deleted: "same",
      trip_date: "input_date",
      advance_bhada: "same",
      balance_bhada: "balance_bhada",
      payable_branch: "same",
      payable_branch_name: "same",
      receiver_name: "same",
      bhada_remarks: "same",
      payment_type: "same",
      is_bhada_paid: "same",
      module_trip_bhada: "same",
      bhada_paid_date: "same",
      id: "same",
      bhada_paid_branch_name: "same",
      fyear: "fYear_get",
      bhada_paid_branch: "same",
      tds_amount: "same",
      net_balance: "same",
      tds_rate: "same",
      payable_declaration: "same",
      // saved changes
      rate_on:"same",
      total_pkg:"same",
      actual_weight:"same",
      our_weight:"same",
      crossing_weight:"same",
      rate:"same",
      truck_weight:"same",
      truck_hire:"same",
      labour:"same",
      labour_calculation:"same",
      other_charge:"same",
      cash_received_by_driver:"same",
      gross_amount:"same",
      tds_rate:"same",
      advance_bhada:"same",
      rebate:"same",
      rebate_calculation:"same",
      crossing:"same",
      crossing_calculation:"same",
      total_to_pay:"same",
      to_be_billed:"same",
      total_to_paid:"same",
      pay_to_driver:"same",
      net_amount:"same",
      is_redux_call:"same",
      broker_name: "same",
    },
    additionalFilterOnResponse: (inputObject) => {
      try{
        if ("bhada_paid_date" in inputObject && inputObject.bhada_paid_date == null){
          console.log("In adfsd");
        //   inputObject.bhada_paid_date = new Date()
      }
      console.log("Hewrereref", inputObject);
      return inputObject;
      }
      catch{
        console.log("Herer");
        return inputObject;
      }

    },
    url: SERVER_URL + "/trip/",
    methodType: "GET",
  },
  generateCwb: {
    responseSchema: {
      status: "same",
      cewb_no: "same",
    },
    url: SERVER_URL + "/ewb/consolidated/",
    methodType: "GET",
  },
  saveTrip: {
    paramSchema: {
      station_from: "same",
      station_to: "same",
      vehicle_id: "same",
      created_from: "same",
      remarks: "same",
      created_by: "same",
      challan_ids: "booking_challan_info",
      amount: "same",
      input_date: "trip_date",
      advance_bhada: "same",
      balance_bhada: "same",
      payable_branch: "same",
      receiver_name: "same",
      bhada_remarks: "same",
      payment_type: "same",
      is_bhada_paid: "same",
      module_trip_bhada: "same",
      bhada_paid_date: "same",
      login_user_id: "modified_by",
      company_id: "companyId",
      fYear: "fyear",
      tds_amount: "same",
      net_balance: "same",
      // check from here
      rate_on:"same",
      total_pkg:"same",
      actual_weight:"same",
      our_weight:"same",
      crossing_weight:"same",
      rate:"same",
      truck_weight:"same",
      truck_hire:"same",
      labour:"same",
      labour_calculation:"same",
      other_charge:"same",
      cash_received_by_driver:"same",
      gross_amount:"same",
      tds_rate:"same",
      advance_bhada:"same",
      rebate:"same",
      rebate_calculation:"same",
      crossing:"same",
      crossing_calculation:"same",
      total_to_pay:"same",
      total_to_paid:"same",
      to_be_billed:"same",
      pay_to_driver:"same",
      net_amount:"same",
      broker_name: "same",
    },
    responseSchema: {
      trip_no: "same",
      status: "same",
    },
    url: SERVER_URL + "/trip/",
    methodType: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      if (!text.trip_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
    additionalFilterOnInput: (inputObject) => {
      console.log("12345678",inputObject);
      if ("module_trip_bhada" in inputObject && inputObject.module_trip_bhada){
          inputObject.is_bhada_paid = true
      }
      return inputObject;
    },
  },
  modifyTrip: {
    paramSchema: {
      station_from: "same",
      station_to: "same",
      vehicle_id: "same",
      created_from: "same",
      remarks: "same",
      created_by: "same",
      challan_ids: "booking_challan_info",
      amount: "same",
      trip_no: "same",
      input_date: "trip_date",
      advance_bhada: "same",
      balance_bhada: "same",
      payable_branch: "same",
      receiver_name: "same",
      bhada_remarks: "same",
      payment_type: "same",
      is_bhada_paid: "same",
      module_trip_bhada: "same",
      bhada_paid_date: "same",
      id:"same",
      login_user_id : "modified_by",
      // bhada_paid_branch:"created_from"
    //   bhada_paid_branch:"paid_branch",
      company_id: "companyId",
      fYear_get: "fyear",
      bhada_paid_branch:"same",
      tds_amount: "same",
      net_balance: "same",

      // saved changes
      rate_on:"same",
      total_pkg:"same",
      actual_weight:"same",
      our_weight:"same",
      crossing_weight:"same",
      rate:"same",
      truck_weight:"same",
      truck_hire:"same",
      labour:"same",
      labour_calculation:"same",
      other_charge:"same",
      cash_received_by_driver:"same",
      gross_amount:"same",
      tds_rate:"same",
      advance_bhada:"same",
      rebate:"same",
      rebate_calculation:"same",
      crossing:"same",
      crossing_calculation:"same",
      total_to_pay:"same",
      total_to_paid:"same",
      to_be_billed:"same",
      pay_to_driver:"same",      
      net_amount:"same",
      broker_name: "same",
      redux_call:0
    },
    responseSchema: {
      trip_no: "same",
      status: "same",
    },
    url: SERVER_URL + "/trip/",
    methodType: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      if (!text.trip_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
    additionalFilterOnInput: (inputObject) => {
      console.log("12345678 modify trip",inputObject);
      if("bhada_paid_date" in inputObject && inputObject.bhada_paid_date == "") {
          inputObject.bhada_paid_date = null;
      }
      if("bhada_paid_branch" in inputObject && inputObject.bhada_paid_branch == "") {
        inputObject.bhada_paid_branch = null;
    }
      if ("module_trip_bhada" in inputObject && inputObject.module_trip_bhada){
          inputObject.is_bhada_paid = true
          inputObject.bhada_paid_branch = JSON.parse(sessionStorage.branch_id).branch_id
      }
      return inputObject;
    },
  },
  modifyTripBhada: {
    paramSchema: {
      station_from: "same",
      station_to: "same",
      vehicle_id: "same",
      created_from: "same",
      remarks: "same",
      created_by: "same",
      challan_ids: "booking_challan_info",
      amount: "same",
      trip_no: "same",
      input_date: "trip_date",
      advance_bhada: "same",
      balance_bhada: "same",
      payable_branch: "same",
      receiver_name: "same",
      bhada_remarks: "same",
      payment_type: "same",
      is_bhada_paid: "same",
      module_trip_bhada: "same",
      bhada_paid_date: "same",
      id:"same",
      login_user_id : "modified_by",
      // bhada_paid_branch:"created_from"
    //   bhada_paid_branch:"paid_branch",
      company_id: "companyId",
      fYear_get: "fyear",
      bhada_paid_branch:"same",
      tds_amount: "same",
      net_balance: "same",
      payable_declaration: "same",
    },
    responseSchema: {
      trip_no: "same",
      status: "same",
    },
    url: SERVER_URL + "/trip/payable_save",
    methodType: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      if (!text.trip_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
    additionalFilterOnInput: (inputObject) => {
      console.log("12345678 modify trip",inputObject);
      inputObject.payable_declaration = parseInt(inputObject.payable_declaration);
      if(inputObject.modified_by != "1" && inputObject.modified_by != "220") {
        inputObject.payable_declaration = parseInt("-1");
      }
      if("bhada_paid_date" in inputObject && inputObject.bhada_paid_date == "") {
          inputObject.bhada_paid_date = null;
      }
      if("bhada_paid_branch" in inputObject && inputObject.bhada_paid_branch == "") {
        inputObject.bhada_paid_branch = null;
    }
      if ("module_trip_bhada" in inputObject && inputObject.module_trip_bhada){
          inputObject.is_bhada_paid = true
          inputObject.bhada_paid_branch = JSON.parse(sessionStorage.branch_id).branch_id
      }
      return inputObject;
    },
  },
  getCitySuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/branch/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getVehicleSuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/vehicle/trip/",
    methodType: "GET",
    respoonseSchema: {},
  },
};

const vehicleRegisterApiConfig = {
  getVehicleRegister: {
    responseSchema: {
      station: "same",
      vehicle_id: "same",
      vehicle_register_id: "same",
      vr_no: "same",
      vehicle_no: "same",
      pass_status: "same",
      memo_no: "same",
      register_date: "same",
      station_name: "same",
      lorry_no: "same",
      freight: "same",
      transport_name: "same",
      remarks: "same",
      received_date: "same",
      received_amount: "same",
      payment_method: "same",
      register_date: "same",
      cheque_details: "same",
      receiver_detail: "same",
      x_date: "same",
      letter_no: "same",
      fyear: "fYear_get",
    },
    // additionalFilterOnResponse: (inputObject) => {
    //   try{
    //     if ("bhada_paid_date" in inputObject && inputObject.bhada_paid_date == null){
    //       console.log("In adfsd");
    //       inputObject.bhada_paid_date = new Date()
    //   }
    //   console.log("Hewrereref", inputObject);
    //   return inputObject;
    //   }
    //   catch{
    //     console.log("Herer");
    //     return inputObject;
    //   }

    // },
    url: SERVER_URL + "/vehicleregister/",
    methodType: "GET",
  },
  saveVehicleRegister: {
    paramSchema: {
      station: "same",
      vehicle_id: "same",
      vr_no: "same",
      vehicle_no: "same",
      pass_status: "same",
      memo_no: "same",
      register_date: "same",
      station_name: "same",
      lorry_no: "same",
      freight: "same",
      transport_name: "same",
      remarks: "same",
      received_date: "same",
      received_amount: "same",
      payment_method: "same",
      register_date: "same",
      cheque_details: "same",
      receiver_detail: "same",
      x_date: "same",
      letter_no: "same",
      company_id: "companyId",
      fYear: "fyear",
    },
    responseSchema: {
      vr_no: "same",
      // status: "same",
    },
    url: SERVER_URL + "/vehicleregister/",
    methodType: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      if (!text.vr_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
    // additionalFilterOnInput: (inputObject) => {
    //   console.log("12345678",inputObject);
    //   if ("module_trip_bhada" in inputObject && inputObject.module_trip_bhada){
    //       inputObject.is_bhada_paid = true
    //   }
    //   return inputObject;
    // },
  },
  modifyVehicleRegister: {
    paramSchema: {
      vehicle_register_id: "same",
      station: "same",
      vehicle_id: "same",
      vr_no: "same",
      vehicle_no: "same",
      pass_status: "same",
      memo_no: "same",
      register_date: "same",
      station_name: "same",
      lorry_no: "same",
      freight: "same",
      transport_name: "same",
      remarks: "same",
      received_date: "same",
      received_amount: "same",
      payment_method: "same",
      register_date: "same",
      cheque_details: "same",
      receiver_detail: "same",
      x_date: "same",
      letter_no: "same",
      company_id: "companyId",
      fYear_get: "fyear",
    },
    responseSchema: {
      vr_no: "same",
      // status: "same",
    },
    url: SERVER_URL + "/vehicleregister/",
    methodType: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      if (!text.vr_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
    additionalFilterOnInput: (inputObject) => {
      console.log("12345678", inputObject);
      if ("module_trip_bhada" in inputObject && inputObject.module_trip_bhada) {
        inputObject.is_bhada_paid = true;
      }
      return inputObject;
    },
  },
  getVehicleSuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/vehicle/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getCitySuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/branch/",
    methodType: "GET",
    respoonseSchema: {},
  },
};

const mrPendingAmountApiConfig = {
  getMrPending: {
    responseSchema: {
      sr_no: "same",
      created_from: "same",
      branch: "branch_name",
      party_name: "same",
      debit_amount: "same",
      remarks: "same",
      mr_list: "mr_entries",
      credit_list: "table_entries",
      date: "input_date",
      fyear: "fYear_get",
    },
    url: SERVER_URL + "/pending_mr_payment/",
    methodType: "GET",
  },
  saveMrPending: {
    paramSchema: {
      created_from: "same",
      branch_name: "branch",
      party_name: "same",
      debit_amount: "same",
      remarks: "same",
      mr_entries: "mr_list",
      table_entries: "credit_list",
      input_date: "date",
      company_id: "companyId",
      fYear: "fyear",
    },
    responseSchema: {
      register_no: "sr_no",
      // status: "same",
    },
    url: SERVER_URL + "/pending_mr_payment/",
    methodType: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      //   if (!text.vr_no) {
      //     console.log("In fff");
      //     throw new Error("The required value must be a number fff");
      //   }
    },
    additionalFilterOnInput: (inputObject) => {
      console.log("12345678", inputObject);
      inputObject.created_from = parseInt(inputObject.created_from);
      inputObject.debit_amount = parseFloat(inputObject.debit_amount);

      let mrList = [];
      inputObject.mr_list.forEach((obj) => {
        mrList.push(obj.mr_no);
      });
      inputObject.mr_list = mrList;

      inputObject.credit_list.forEach((obj) => {
        obj.credit_date = new Date(obj.credit_date).toISOString();
      });

      inputObject.date = new Date(inputObject.date).toISOString();

      return inputObject;
    },
  },
  modifyMrPending: {
    paramSchema: {
      sr_no: "register_no",
      created_from: "same",
      branch_name: "branch",
      party_name: "same",
      debit_amount: "same",
      remarks: "same",
      mr_entries: "mr_list",
      table_entries: "credit_list",
      input_date: "date",
      fYear_get: "fyear",
      company_id: "companyId",
    },
    responseSchema: {
      sr_no: "same",
      // status: "same",
    },
    url: SERVER_URL + "/pending_mr_payment",
    methodType: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      //   if (!text.vr_no) {
      //     console.log("In fff");
      //     throw new Error("The required value must be a number fff");
      //   }
    },
    additionalFilterOnInput: (inputObject) => {
      console.log("12345678", inputObject);
      inputObject.created_from = parseInt(inputObject.created_from);
      inputObject.debit_amount = parseFloat(inputObject.debit_amount);

      let mrList = [];
      inputObject.mr_list.forEach((obj) => {
        mrList.push(obj.mr_no);
      });
      inputObject.mr_list = mrList;

      inputObject.credit_list.forEach((obj) => {
        obj.credit_date = new Date(obj.credit_date).toISOString();
      });

      inputObject.date = new Date(inputObject.date).toISOString();

      return inputObject;
    },
  },
  getVehicleSuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/vehicle/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getCitySuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/branch/",
    methodType: "GET",
    respoonseSchema: {},
  },
};

const BankClearanceApiConfig = {
  modifyBankClearance: {
    paramSchema: {
      clearance_entries: "same",
      consignor_id: "bank_id",
      date_from: "same",
      date_to: "same",
      voucher_type: "same",
      clearance_status: "same",
      created_from: "same",
      company_id: "companyId",
      fYear_get: "fyear",
    },
    // responseSchema: {
    // //   vr_no: "same",
    //   // status: "same",
    // },
    url: SERVER_URL + "/account_trans/bank_clearance",
    methodType: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    additionalFilterOnInput: (inputObject) => {
      console.log("12345678", inputObject);
      inputObject["clearance_entries"].forEach((row) => {
        if (row.date != null) {
          const tmp = row.date.split("-").reverse().join("-");
          row.date = new Date(tmp).toISOString();
        }
        if (row.clearance_date != null) {
          const tmp = row.clearance_date.split("-").reverse().join("-");
          row.clearance_date = new Date(tmp).toISOString();
        }
        row.clearance_status = parseInt(row.clearance_status);
      });
      console.log("12345678", inputObject);

      const firstObj = {
        bank_id: inputObject.bank_id,
        clearance_status: parseInt(inputObject.clearance_status),
        created_from: inputObject.created_from,
        date_from: new Date(inputObject.date_from).toISOString(),
        date_to: new Date(inputObject.date_to).toISOString(),
        voucher_type: inputObject.voucher_type,
        transaction_id: "1",
      };
      let finalData = [firstObj, ...inputObject["clearance_entries"]];

      console.log("final data: ", finalData);
      return finalData;
    },
  },
  getConsignorSuggestions: {
    url: SERVER_URL + "/consignor/",
    methodType: "GET",
    respoonseSchema: {},
  },
};

const challanInwardApiConfig = {
  getTrip: {
    responseSchema: {
      station_from: "same",
      station_to: "same",
      destination: "same",
      station_from_name: "same",
      station_to_name: "same",
      destination_name: "same",
      vehicle_id: "same",
      vehicle_no: "same",
      created_from: "same",
      remarks: "same",
      created_by: "same",
      booking_chalan_info: "challan_ids",
      driver_name: "same",
      owner_name: "same",
      status: "same",
      amount: "same",
      fyear: "fYear_get",
    },
    url: SERVER_URL + "/trip/",
    methodType: "GET",
  },
  generateCwb: {
    responseSchema: {
      status: "same",
      cewb_no: "same",
    },
    url: SERVER_URL + "/ewb/consolidated/",
    methodType: "GET",
  },
  saveTrip: {
    paramSchema: {
      station_from: "same",
      station_to: "same",
      vehicle_id: "same",
      created_from: "same",
      remarks: "same",
      created_by: "same",
      challan_ids: "booking_challan_info",
      amount: "same",
      company_id: "companyId",
      fyear: "fYear",
    },
    responseSchema: {
      trip_no: "same",
      status: "same",
    },
    url: SERVER_URL + "/trip/",
    methodType: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      if (!text.trip_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
    additionalFilterOnInput: (inputObject) => {
      if ("module_trip_bhada" in inputObject && inputObject.module_trip_bhada) {
        inputObject.is_bhada_paid = true;
      }
      return inputObject;
    },
  },
  modifyTrip: {
    paramSchema: {
      station_from: "same",
      station_to: "same",
      vehicle_id: "same",
      created_from: "same",
      remarks: "same",
      created_by: "same",
      challan_ids: "booking_challan_info",
      amount: "same",
      trip_no: "same",
      company_id: "companyId",
      fYear_get: "fyear",
    },
    responseSchema: {
      trip_no: "same",
      status: "same",
    },
    url: SERVER_URL + "/trip/",
    methodType: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      if (!text.trip_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
    // additionalFilterOnInput: (inputObject) => {
    //     if (inputObject.eway_bill_info &&
    //         inputObject.eway_bill_info.length==1 &&
    //         inputObject.eway_bill_info[0].eway_bill_no == ""){
    //         delete inputObject.eway_bill_info
    //     }
    //     return inputObject;
    // },
  },
  getCitySuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/branch/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getVehicleSuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/vehicle/",
    methodType: "GET",
    respoonseSchema: {},
  },
};

const accountMasterApiConfig = {
  getTransporterSuggestions: {
    url: SERVER_URL + "/transporter/",
    methodType: "POST",
    respoonseSchema: {},
    additionalFilterOnResponse: (inputObject) => {
      console.log("inside getTransporterSuggestions", inputObject);
      if ("branch_info" in inputObject) {
        let newArray = [];
        for (let i = 0; i < inputObject.branch_info.length; i++) {
          newArray.push(String(inputObject.branch_info[i]));
        }
        inputObject.branch_info = newArray;
      }
      return inputObject;
    },
  },
  getGroupSuggestions: {
    url: SERVER_URL + "/group/",
    methodType: "POST",
    respoonseSchema: {},
  },
  getSubGroupSuggestions: {
    url: SERVER_URL + "/subgroup/",
    methodType: "POST",
    respoonseSchema: {},
  },
  getGroupNameSuggestions: {
    url: SERVER_URL + "/company_group/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getAccountMaster: {
    responseSchema: {
      vehicle_no: "same",
      pan_no: "same",
      owner_name: "same",
      owner_address: "same",
      body_type: "same",
      engine_no: "same",
      chasis_no: "same",
      permit_no: "same",
      permit_validity: "same",
      insurance_company: "same",
      policy_validity: "same",
      policy_no: "same",
      driver_name: "same",
      driver_address: "same",
      license_no: "same",
      license_validity: "same",
    },
    url: SERVER_URL + "/vehicle/",
    methodType: "GET",
  },
  saveAccountMaster: {
    paramSchema: {
      id: "same",
      name: "same",
      gst: "same",
      address: "same",
      is_door_delivery: "same",
      collection_charge: "same",
      collection_charge_unit: "same",
      contact_person: "same",
      suffix: "same",
      bilty_charge: "same",
      hamali_charge: "same",
      door_delivery_charge: "same",
      commission_rate: "same",
      acknowledgement: "same",
      city: "same",
      is_active: "same",
      pincode: "same",
      delivery_address: "same",
      phone_office: "same",
      phone_residence: "same",
      mobile: "same",
      email: "same",
      tin_no: "same",
      cst_no: "same",
      pan_no: "same",
      limit_amt: "same",
      group_id: "same",
      subgroup_id: "same",
      group_name: "same",
      created_by: "same",
      modified_by: "same",
      branch_info: "same",
      branch_list: "same",
      automatic_billing: "same",
      only_pod_bill: "same",
      company_info: "same",
      secondary_email: "same",
      is_account_related: "same",
      is_daily_mail: "same",
      company_id: "companyId",
      //   fyear: "fYear",
      is_transporter: "same",
      bill_name: "same",
      bill_gst: "same",
      auto_pod_statement: "same",
    },
    responseSchema: {
      booking_chalan_no: "challan_no",
      status: "same",
    },
    url: SERVER_URL + "/transporter/add/",
    methodType: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      // if (!text.challan_no) {
      //   console.log("In fff");
      //   throw new Error("The required value must be a number fff");
      // }
    },
    additionalFilterOnInput: (inputObject) => {
      let dummyObject = lodash.cloneDeep(inputObject);
      for (let key in dummyObject) {
        if (dummyObject[key] == "") {
          dummyObject[key] = null;
        }
      }
      dummyObject = convertToUpperCase(dummyObject);
      return dummyObject;
    },
  },
  modifyVehicle: {
    paramSchema: {
      vehicle_no: "same",
      pan_no: "same",
      owner_name: "same",
      owner_address: "same",
      body_type: "same",
      engine_no: "same",
      chasis_no: "same",
      permit_no: "same",
      permit_validity: "same",
      insurance_company: "same",
      policy_validity: "same",
      policy_no: "same",
      driver_name: "same",
      driver_address: "same",
      license_no: "same",
      license_validity: "same",
      created_from: "same",
      created_by: "same",
      company_id: "companyId",
      //   fYear: "fyear",
    },
    responseSchema: {
      booking_chalan_no: "challan_no",
      status: "same",
    },
    url: SERVER_URL + "/vehicle/",
    methodType: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      // if (!text.challan_no) {
      //   console.log("In fff");
      //   throw new Error("The required value must be a number fff");
      // }
    },
    additionalFilterOnInput: (inputObject) => {
      let dummyObject = lodash.cloneDeep(inputObject);
      for (let key in dummyObject) {
        if (dummyObject[key] == "") {
          dummyObject[key] = null;
        }
      }
      dummyObject = convertToUpperCase(dummyObject);
      return dummyObject;
    },
  },
};

const biltyStatementApiConfig = {
  saveBiltyStatement: {
    paramSchema: {
      created_from: "same",
      created_by: "same",
      paid_statement_no: "same",
      created_by_name: "same",
      bilty_info_list: "bilty_info",
      input_date: "paid_statement_date",
      company_id: "companyId",
      fYear: "fyear",
    },
    responseSchema: {
      paid_statement_no: "same",
      status: "same",
    },
    url: SERVER_URL + "/paid_statement/",
    methodType: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  },
  modifyBiltyStatement: {
    paramSchema: {
      created_from: "same",
      created_by: "same",
      paid_statement_no: "same",
      created_by_name: "same",
      bilty_info_list: "bilty_info",
      input_date: "paid_statement_date",
      company_id: "companyId",
      fYear: "fyear",
    },
    responseSchema: {
      paid_statement_no: "same",
      status: "same",
    },
    url: SERVER_URL + "/paid_statement/",
    methodType: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    //   validateResponse: (text) => {
    //     // We only throw the error if the incoming data status is not equal to "ok"
    //     // if (!text.trip_no) {
    //     //   console.log("In fff");
    //     //   throw new Error("The required value must be a number fff");
    //     // }
    //   },
    //   // additionalFilterOnInput: (inputObject) => {
    //   //     if (inputObject.eway_bill_info &&
    //   //         inputObject.eway_bill_info.length==1 &&
    //   //         inputObject.eway_bill_info[0].eway_bill_no == ""){
    //   //         delete inputObject.eway_bill_info
    //   //     }
    //   //     return inputObject;
    //   // },
  },
};

const mrStatementApiConfig = {
  saveMrStatement: {
    paramSchema: {
      mr_statement_no: "same",
      input_date: "created_date",
      created_from: "same",
      created_by: "same",
      mr_info_list: "same",
      company_id: "companyId",
      fYear: "fyear",
    },
    responseSchema: {
      mr_statement_no: "same",
      status: "same",
    },
    url: SERVER_URL + "/mr_statement/",
    methodType: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      // if (!text.trip_no) {
      //   console.log("In fff");
      //   throw new Error("The required value must be a number fff");
      // }
    },
    // additionalFilterOnInput: (inputObject) => {
    //     if (inputObject.eway_bill_info &&
    //         inputObject.eway_bill_info.length==1 &&
    //         inputObject.eway_bill_info[0].eway_bill_no == ""){
    //         delete inputObject.eway_bill_info
    //     }
    //     return inputObject;
    // },
  },
  modifyTrip: {
    paramSchema: {
      station_from: "same",
      station_to: "same",
      vehicle_id: "same",
      created_from: "same",
      remarks: "same",
      created_by: "same",
      challan_ids: "booking_challan_info",
      amount: "same",
      trip_no: "same",
      company_id: "companyId",
      fYear: "fyear",
    },
    responseSchema: {
      trip_no: "same",
      status: "same",
    },
    url: SERVER_URL + "/trip/",
    methodType: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      if (!text.trip_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
    // additionalFilterOnInput: (inputObject) => {
    //     if (inputObject.eway_bill_info &&
    //         inputObject.eway_bill_info.length==1 &&
    //         inputObject.eway_bill_info[0].eway_bill_no == ""){
    //         delete inputObject.eway_bill_info
    //     }
    //     return inputObject;
    // },
  },
  getCitySuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/branch/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getVehicleSuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/vehicle/",
    methodType: "GET",
    respoonseSchema: {},
  },
};

const podChallanInwardApiConfig = {
  getTrip: {
    responseSchema: {
      station_from: "same",
      station_to: "same",
      destination: "same",
      station_from_name: "same",
      station_to_name: "same",
      destination_name: "same",
      vehicle_id: "same",
      vehicle_no: "same",
      created_from: "same",
      remarks: "same",
      created_by: "same",
      booking_chalan_info: "pod_info_list",
      driver_name: "same",
      owner_name: "same",
      status: "same",
      amount: "same",
      fyear: "fYear_get",
    },
    url: SERVER_URL + "/trip/",
    methodType: "GET",
  },
  generateCwb: {
    responseSchema: {
      status: "same",
      cewb_no: "same",
    },
    url: SERVER_URL + "/ewb/consolidated/",
    methodType: "GET",
  },
  saveTrip: {
    paramSchema: {
      station_from: "same",
      station_to: "same",
      vehicle_id: "same",
      created_from: "same",
      remarks: "same",
      created_by: "same",
      challan_ids: "booking_challan_info",
      amount: "same",
      company_id: "companyId",
      fYear: "fyear",
    },
    responseSchema: {
      trip_no: "same",
      status: "same",
    },
    url: SERVER_URL + "/trip/",
    methodType: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      if (!text.trip_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
    // additionalFilterOnInput: (inputObject) => {
    //     if (inputObject.eway_bill_info &&
    //         inputObject.eway_bill_info.length==1 &&
    //         inputObject.eway_bill_info[0].eway_bill_no == ""){
    //         delete inputObject.eway_bill_info
    //     }
    //     return inputObject;
    // },
  },
  modifyTrip: {
    paramSchema: {
      station_from: "same",
      station_to: "same",
      vehicle_id: "same",
      created_from: "same",
      remarks: "same",
      created_by: "same",
      challan_ids: "booking_challan_info",
      amount: "same",
      trip_no: "same",
      fYear_get: "fyear",
    },
    responseSchema: {
      trip_no: "same",
      status: "same",
    },
    url: SERVER_URL + "/trip/",
    methodType: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      if (!text.trip_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
    // additionalFilterOnInput: (inputObject) => {
    //     if (inputObject.eway_bill_info &&
    //         inputObject.eway_bill_info.length==1 &&
    //         inputObject.eway_bill_info[0].eway_bill_no == ""){
    //         delete inputObject.eway_bill_info
    //     }
    //     return inputObject;
    // },
  },
  getCitySuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/branch/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getVehicleSuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/vehicle/",
    methodType: "GET",
    respoonseSchema: {},
  },
};

const itemMasterApiConfig = {
  getItemMaster: {
    responseSchema: {
      name: "same",
      description: "same",
      id: "item_id",
    },
    url: SERVER_URL + "/itemx/",
    methodType: "GET",
  },
  saveItemMaster: {
    paramSchema: {
      name: "same",
      description: "desc",
      item_id: "item_id",
    },
    url: SERVER_URL + "/item/create/",
    methodType: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      //   if (!text.challan_no) {
      //     console.log("In fff");
      //     throw new Error("The required value must be a number fff");
      //   }
    },
    additionalFilterOnInput: (inputObject) => {
      let dummyObject = lodash.cloneDeep(inputObject);
      for (let key in dummyObject) {
        if (dummyObject[key] == "") {
          dummyObject[key] = null;
        }
      }
      return dummyObject;
    },
  },
  modifyItemMaster: {
    paramSchema: {
      name: "same",
      description: "desc",
      item_id: "same",
    },
    responseSchema: {
      booking_chalan_no: "challan_no",
      status: "same",
    },
    url: SERVER_URL + "/item/update/",
    methodType: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      //   if (!text.challan_no) {
      //     console.log("In fff");
      //     throw new Error("The required value must be a number fff");
      //   }
    },
    additionalFilterOnInput: (inputObject) => {
      let dummyObject = lodash.cloneDeep(inputObject);
      for (let key in dummyObject) {
        if (dummyObject[key] == "") {
          dummyObject[key] = null;
        }
      }
      return dummyObject;
    },
  },
  getItemSuggestions: {
    url: SERVER_URL + "/item/",
    methodType: "POST",
    respoonseSchema: {},
    // tailTruncate: true,
  },
};
const mrBillingApiConfig = {
  getCrossingBill: {
    responseSchema: {
      id: "same",
      consignor_name: "same",
      consignor_id: "same",
      total_amount: "same",
      add: "same",
      net_amount: "same",
      description1: "same",
      amt1: "same",
      description2: "same",
      bill_no: "same",
      amt2: "same",
      bilty_charge: "same",
      door_del_charge: "same",
      extra_hamali: "same",
      extra_percentage: "same",
      extra_percentage_amount: "same",
      mr_info: "mr_ids",
      created_from: "same",
      created_by: "same",
      date_to: "input_date",
      bill_date: "same",
      amount: "gross_amount",
      edit_bill: "same",
      fyear: "fYear_get",
    },
    url: SERVER_URL + "/delivery_billing_statement/",
    methodType: "GET",
    additionalFilterOnResponse: (inputObject) => {
      console.log("input object", inputObject);
      for (let i = 0; i < inputObject.mr_info.length; i++) {
        inputObject.mr_info[i].checked = "1";
      }
      return inputObject;
    },
  },
  getEwbInfo: {
    responseSchema: {
      consignor_id: "same",
      consignor_name: "same",
      consignee_name: "same",
      consignor_gst: "same",
      consignee_gst: "same",
      consignee_id: "same",
      goods_invoice_value: "same",
    },
    url: SERVER_URL + "/ewb/",
    methodType: "POST",
    additionalFilterOnResponse: additionalFilterOnResponseForGetEwb,
  },
  saveCrossingBill: {
    paramSchema: {
      id: "same",
      bill_no: "same",
      consignor_id: "same",
      total_amount: "same",
      add: "same",
      description1: "same",
      amt1: "same",
      description2: "same",
      amt2: "same",
      bilty_charge: "same",
      door_del_charge: "same",
      extra_hamali: "same",
      extra_percentage: "same",
      extra_percentage_amount: "same",
      net_amount: "same",
      mr_ids: "bilty_info",
      created_from: "same",
      created_by: "same",
      input_date: "date_to",
      bill_date: "same",
      // input_date: "same",
      gross_amount: "amount",
      company_id: "companyId",
      fYear: "fyear",
    },
    responseSchema: {
      bill_no: "id",
    },
    url: SERVER_URL + "/delivery_billing_statement/",
    methodType: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    // validateResponse: (text) => {
    //   // We only throw the error if the incoming data status is not equal to "ok"
    //   if (!text.bilty_no) {
    //     console.log("In fff");
    //     throw new Error("The required value must be a number fff");
    //   }
    // },
    additionalFilterOnInput: (inputObject) => {
      if (inputObject.id == "") {
        inputObject.id = null;
      }
      if (inputObject.bill_no == "") {
        inputObject.bill_no = null;
      }
      let dummyArray = [];
      for (let i = 0; i < inputObject.bilty_info.length; i++) {
        if (inputObject.bilty_info[i].checked == "1") {
          dummyArray.push(inputObject.bilty_info[i]);
        }
      }
      inputObject.bilty_info = dummyArray;
      return inputObject;
    },
  },
  modifyCrossingBill: {
    paramSchema: {
      id: "same",
      bill_no: "same",
      consignor_id: "same",
      total_amount: "same",
      add: "same",
      bill_no: "same",
      description1: "same",
      amt1: "same",
      description2: "same",
      amt2: "same",
      bilty_charge: "same",
      door_del_charge: "same",
      extra_hamali: "same",
      extra_percentage: "same",
      extra_percentage_amount: "same",
      net_amount: "same",
      mr_ids: "bilty_info",
      created_from: "same",
      created_by: "same",
      input_date: "date_to",
      bill_date: "same",
      // input_date: "same",
      gross_amount: "amount",
      company_id: "companyId",
      fYear_get: "fyear",
    },
    responseSchema: {
      bill_no: "id",
    },
    url: SERVER_URL + "/delivery_billing_statement/",
    methodType: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    // validateResponse: (text) => {
    //   // We only throw the error if the incoming data status is not equal to "ok"
    //   if (!text.bilty_no) {
    //     console.log("In fff");
    //     throw new Error("The required value must be a number fff");
    //   }
    // },
    additionalFilterOnInput: (inputObject)=>{
      if (inputObject.id == ""){
        inputObject.id = null
      }
      let dummyArray = []
      for (let i=0; i<inputObject.bilty_info.length; i++){
        if(inputObject.bilty_info[i].checked == "1"){
          dummyArray.push(inputObject.bilty_info[i]);
        }
      }
      inputObject.bilty_info = dummyArray
      return inputObject
    },
  },
  getConsignorSuggestions: {
    url: SERVER_URL + "/consignor/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getConsigneeSuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/consignee/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getConsigneeSuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/consignee/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getItemSuggestions: {
    url: SERVER_URL + "/item/id",
    methodType: "POST",
    respoonseSchema: {},
    tailTruncate: true,
  },
  getTransporterSuggestions: {
    url: SERVER_URL + "/transporter/",
    methodType: "POST",
    respoonseSchema: {},
  },
};
const NarrationMasterApiConfig = {
  saveNarrationMaster: {
    paramSchema: {
      name: "same",
      belongs_to: "same",
      item_id: "id",
      company_id: "companyId",
    },
    url: SERVER_URL + "/narration/",
    methodType: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      //   if (!text.challan_no) {
      //     console.log("In fff");
      //     throw new Error("The required value must be a number fff");
      //   }
    },
    additionalFilterOnInput: (inputObject) => {
      let dummyObject = lodash.cloneDeep(inputObject);
      for (let key in dummyObject) {
        if (dummyObject[key] == "") {
          dummyObject[key] = null;
        }
      }
      return dummyObject;
    },
  },
  modifyItemMaster: {
    paramSchema: {
      name: "same",
      description: "desc",
      item_id: "same",
    },
    responseSchema: {
      booking_chalan_no: "challan_no",
      status: "same",
    },
    url: SERVER_URL + "/item/update/",
    methodType: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      //   if (!text.challan_no) {
      //     console.log("In fff");
      //     throw new Error("The required value must be a number fff");
      //   }
    },
    additionalFilterOnInput: (inputObject) => {
      let dummyObject = lodash.cloneDeep(inputObject);
      for (let key in dummyObject) {
        if (dummyObject[key] == "") {
          dummyObject[key] = null;
        }
      }
      return dummyObject;
    },
  },
  getNarrationSuggestions: {
    url: SERVER_URL + "/narration/",
    methodType: "POST",
    respoonseSchema: {},
    // tailTruncate: true,
  },
};

const GroupMasterApiConfig = {
  saveGroupMaster: {
    paramSchema: {
      name: "same",
      belongs_to: "same",
      item_id: "id",
      company_id: "companyId",
    },
    url: SERVER_URL + "/group/update",
    methodType: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      //   if (!text.challan_no) {
      //     console.log("In fff");
      //     throw new Error("The required value must be a number fff");
      //   }
    },
    additionalFilterOnInput: (inputObject) => {
      let dummyObject = lodash.cloneDeep(inputObject);
      for (let key in dummyObject) {
        if (dummyObject[key] == "") {
          dummyObject[key] = null;
        }
      }
      return dummyObject;
    },
  },
  modifyItemMaster: {
    paramSchema: {
      name: "same",
      description: "desc",
      item_id: "same",
    },
    responseSchema: {
      booking_chalan_no: "challan_no",
      status: "same",
    },
    url: SERVER_URL + "/item/update/",
    methodType: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      //   if (!text.challan_no) {
      //     console.log("In fff");
      //     throw new Error("The required value must be a number fff");
      //   }
    },
    additionalFilterOnInput: (inputObject) => {
      let dummyObject = lodash.cloneDeep(inputObject);
      for (let key in dummyObject) {
        if (dummyObject[key] == "") {
          dummyObject[key] = null;
        }
      }
      return dummyObject;
    },
  },
  getGroupSuggestions: {
    url: SERVER_URL + "/group/",
    methodType: "POST",
    respoonseSchema: {},
    // tailTruncate: true,
  },
};

const SubgroupMasterApiConfig = {
  saveSubgroupMaster: {
    paramSchema: {
      name: "same",
      belongs_to: "group_id",
      item_id: "id",
      company_id: "companyId",
    },
    url: SERVER_URL + "/subgroup/update",
    methodType: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      //   if (!text.challan_no) {
      //     console.log("In fff");
      //     throw new Error("The required value must be a number fff");
      //   }
    },
    additionalFilterOnInput: (inputObject) => {
      let dummyObject = lodash.cloneDeep(inputObject);
      for (let key in dummyObject) {
        if (dummyObject[key] == "") {
          dummyObject[key] = null;
        }
      }
      return dummyObject;
    },
  },
  modifyItemMaster: {
    paramSchema: {
      name: "same",
      description: "desc",
      item_id: "same",
    },
    responseSchema: {
      booking_chalan_no: "challan_no",
      status: "same",
    },
    url: SERVER_URL + "/item/update/",
    methodType: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      //   if (!text.challan_no) {
      //     console.log("In fff");
      //     throw new Error("The required value must be a number fff");
      //   }
    },
    additionalFilterOnInput: (inputObject) => {
      let dummyObject = lodash.cloneDeep(inputObject);
      for (let key in dummyObject) {
        if (dummyObject[key] == "") {
          dummyObject[key] = null;
        }
      }
      return dummyObject;
    },
  },
  getSubgroupSuggestions: {
    url: SERVER_URL + "/subgroup/",
    methodType: "POST",
    respoonseSchema: {},
    // tailTruncate: true,
  },
};

const vehicleApiConfig = {
  getVehicle: {
    responseSchema: {
      vehicle_no: "same",
      pan_no: "same",
      owner_name: "same",
      owner_no : "same",
      owner_address: "same",
      body_type: "same",
      engine_no: "same",
      chasis_no: "same",
      permit_no: "same",
      permit_validity: "same",
      insurance_company: "same",
      policy_validity: "same",
      policy_no: "same",
      driver_name: "same",
      driver_no : "same",
      driver_address: "same",
      license_no: "same",
      license_validity: "same",
      vehocle_ownership: "same",
      second_owner_name: "same",
      second_owner_address: "same",
      second_owner_pan_no: "same",
      second_owner_entry_date: "same",
      third_owner_name: "same",
      third_owner_address: "same",
      third_owner_pan_no: "same",
      third_owner_entry_date: "same",
      effective_date: "same",
      //   verified_by: "same",
    },
    url: SERVER_URL + "/vehicle/",
    methodType: "GET",
  },
  saveVehicle: {
    paramSchema: {
      vehicle_id: "same",
      vehicle_no: "same",
      pan_no: "same",
      owner_name: "same",
      owner_no : "same",
      owner_address: "same",
      body_type: "same",
      engine_no: "same",
      chasis_no: "same",
      permit_no: "same",
      permit_validity: "same",
      insurance_company: "same",
      policy_validity: "same",
      policy_no: "same",
      driver_name: "same",
      driver_no : "same",
      driver_address: "same",
      license_no: "same",
      license_validity: "same",
      vehicle_ownership: "same",
      second_owner_name: "same",
      second_owner_address: "same",
      second_owner_pan_no: "same",
      second_owner_entry_date: "same",
      third_owner_name: "same",
      third_owner_address: "same",
      third_owner_pan_no: "same",
      third_owner_entry_date: "same",
      entry_date: "same",
      created_from: "same",
      created_by: "same",
      verified_by: "same",
      tds_rate: "same",
      is_active: "same",
      effective_date: "same",
    },
    responseSchema: {
      vehicle_no: "vehicle_no",
      status: "same",
    },
    url: SERVER_URL + "/vehicle/add/",
    methodType: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      if (!text.vehicle_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
    additionalFilterOnInput: (inputObject) => {
      let dummyObject = lodash.cloneDeep(inputObject);
      if (dummyObject.permit_validity != "") {
        let dummyArray = dummyObject.permit_validity.split("-");
        dummyObject.permit_validity =
          dummyArray[2] + "-" + dummyArray[1] + "-" + dummyArray[0];
      }
      if (dummyObject.policy_validity != "") {
        let dummyArray = dummyObject.policy_validity.split("-");
        dummyObject.policy_validity =
          dummyArray[2] + "-" + dummyArray[1] + "-" + dummyArray[0];
      }
      if (dummyObject.license_validity != "") {
        let dummyArray = dummyObject.license_validity.split("-");
        dummyObject.license_validity =
          dummyArray[2] + "-" + dummyArray[1] + "-" + dummyArray[0];
      }
      for (let key in dummyObject) {
        if (key === "tds_rate" && (dummyObject[key] == null || dummyObject[key] === "")) {
          dummyObject[key] = 0;
        } else if (dummyObject[key] === "") {
          dummyObject[key] = null;
        }
      }
      return dummyObject;
    },
  },
  modifyVehicle: {
    paramSchema: {
      vehicle_no: "same",
      pan_no: "same",
      owner_name: "same",
      owner_no:"same",
      owner_address: "same",
      body_type: "same",
      engine_no: "same",
      chasis_no: "same",
      permit_no: "same",
      permit_validity: "same",
      insurance_company: "same",
      policy_validity: "same",
      policy_no: "same",
      driver_name: "same",
      driver_no :"same", 
      driver_address: "same",
      license_no: "same",
      license_validity: "same",
      created_from: "same",
      created_by: "same",
      verified_by: "same",
      tds_rate: "same",
    },
    responseSchema: {
      booking_chalan_no: "challan_no",
      status: "same",
    },
    url: SERVER_URL + "/vehicle/",
    methodType: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      if (!text.challan_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
    additionalFilterOnInput: (inputObject) => {
      let dummyObject = lodash.cloneDeep(inputObject);
      for (let key in dummyObject) {
        if (key === "tds_rate" && (dummyObject[key] == null || dummyObject[key] === "")) {
          dummyObject[key] = 0;
        } else if (dummyObject[key] === "") {
          dummyObject[key] = null;
        }
      }
      return dummyObject;
    },
  },
  getVehicleSuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/vehicle/",
    methodType: "GET",
    respoonseSchema: {},
    additionalFilterOnResponse: (dummyObject) => {
      console.log("Herer", dummyObject);
      if (
        dummyObject.permit_validity != "" &&
        dummyObject.permit_validity != null
      ) {
        let dummyArray = dummyObject.permit_validity.split("-");
        dummyObject.permit_validity =
          dummyArray[2] + "-" + dummyArray[1] + "-" + dummyArray[0];
      }
      if (
        dummyObject.policy_validity != "" &&
        dummyObject.policy_validity != null
      ) {
        let dummyArray = dummyObject.policy_validity.split("-");
        dummyObject.policy_validity =
          dummyArray[2] + "-" + dummyArray[1] + "-" + dummyArray[0];
      }
      if (
        dummyObject.license_validity != "" &&
        dummyObject.license_validity != null
      ) {
        let dummyArray = dummyObject.license_validity.split("-");
        dummyObject.license_validity =
          dummyArray[2] + "-" + dummyArray[1] + "-" + dummyArray[0];
      }
      console.log("return obj", dummyObject);
      return dummyObject;
    },
  },
};

const lrMasterApiConfig = {
  getCitySuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/branch/",
    methodType: "GET",
    respoonseSchema: {},
  },
  saveLrMaster: {
    paramSchema: {
      branch_id: "same",
      start_no: "same",
      end_no: "same",
    },
    responseSchema: {
    },
    url: SERVER_URL + "/branch/assign_bilty_no/",
    methodType: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
    },
    additionalFilterOnInput: (inputObject) => {
      let dummyObject = lodash.cloneDeep(inputObject);
      for (let key in dummyObject) {
        if (dummyObject[key] == "") {
          dummyObject[key] = null;
        }
        if (key == "start_no" || key == "end_no") {
          dummyObject[key] = parseInt(dummyObject[key]);
        }
      }
      return dummyObject;
    },    
  },
};

const stationMasterApiConfig = {
  getCitySuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/branch/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getStationMaster: {
    responseSchema: {
      vehicle_no: "same",
      suffix: "same",
      pan_no: "same",
      owner_name: "same",
      owner_address: "same",
      body_type: "same",
      engine_no: "same",
      chasis_no: "same",
      permit_no: "same",
      permit_validity: "same",
      insurance_company: "same",
      policy_validity: "same",
      policy_no: "same",
      driver_name: "same",
      driver_address: "same",
      license_no: "same",
      license_validity: "same",
    },
    url: SERVER_URL + "/vehicle/",
    methodType: "GET",
  },
  saveStationMaster: {
    paramSchema: {
      name: "same",
      suffix: "same",
      address: "same",
      branch_id: "same",
      is_branch: "same",
      city: "same",
      pin_code: "same",
      state: "same",
      mobile: "same",
      consignor_id: "party_bill_account",
      freight_lock: "same",
      to_pay_account_name: "same",
      to_pay_account_id: "to_pay_account",
      is_agency: "same"
    },
    responseSchema: {
      booking_chalan_no: "challan_no",
      status: "same",
    },
    url: SERVER_URL + "/branch/add/",
    methodType: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      //   if (!text.challan_no) {
      //     console.log("In fff");
      //     throw new Error("The required value must be a number fff");
      //   }
    },
    additionalFilterOnInput: (inputObject) => {
      let dummyObject = lodash.cloneDeep(inputObject);

       // Validation for state
      if (!dummyObject.state || dummyObject.state.trim() === "") {
        throw new Error("State Name is required and cannot be empty.");
      }

      for (let key in dummyObject) {
        if (key == "is_branch" && dummyObject[key] == 0 ) {
          dummyObject[key] = parseInt(0);
        } 
        else if (dummyObject[key] == "") {
          dummyObject[key] = null;
        }
      }
      return dummyObject;
    },
  },
  modifyStatoinMaster: {
    paramSchema: {
      vehicle_no: "same",
      suffix: "same",
      pan_no: "same",
      owner_name: "same",
      owner_address: "same",
      body_type: "same",
      engine_no: "same",
      chasis_no: "same",
      permit_no: "same",
      permit_validity: "same",
      insurance_company: "same",
      policy_validity: "same",
      policy_no: "same",
      driver_name: "same",
      driver_address: "same",
      license_no: "same",
      license_validity: "same",
      created_from: "same",
      created_by: "same",
      freight_lock: "same",
      to_pay_account_name: "same",
      to_pay_account_id: "to_pay_account",
      is_agency: "same",
      state: "same"
    },
    responseSchema: {
      booking_chalan_no: "challan_no",
      status: "same",
    },
    url: SERVER_URL + "/vehicle/",
    methodType: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      //   if (!text.challan_no) {
      //     console.log("In fff");
      //     throw new Error("The required value must be a number fff");
      //   }
    },
    additionalFilterOnInput: (inputObject) => {
      let dummyObject = lodash.cloneDeep(inputObject);
      for (let key in dummyObject) {
        if (dummyObject[key] == "") {
          dummyObject[key] = null;
        }
      }
      return dummyObject;
    },
  },
  getConsignorSuggestions: {
    url: SERVER_URL + "/consignor/",
    methodType: "GET",
    respoonseSchema: {},
  },
};

const SubStationMasterApiConfig = {
  getCitySuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/branch/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getStationMaster: {
    responseSchema: {
      vehicle_no: "same",
      suffix: "same",
      pan_no: "same",
      owner_name: "same",
      owner_address: "same",
      body_type: "same",
      engine_no: "same",
      chasis_no: "same",
      permit_no: "same",
      permit_validity: "same",
      insurance_company: "same",
      policy_validity: "same",
      policy_no: "same",
      driver_name: "same",
      driver_address: "same",
      license_no: "same",
      license_validity: "same",
      is_branch: "same",
      is_deleted: "same"
    },
    url: SERVER_URL + "/vehicle/",
    methodType: "GET",
  },
  saveSubStationMaster: {
    paramSchema: {
      name: "same",
      suffix: "same",
      address: "same",
      branch_id: "same",
      is_branch: "same",
      city: "same",
      pin_code: "same",
      state: "same",
      mobile: "same",
      consignor_id: "party_bill_account",
      freight_lock: "same",
      to_pay_account_name: "same",
      to_pay_account_id: "to_pay_account",
      is_agency: "same",
      is_deleted: "same"
    },
    responseSchema: {
      booking_chalan_no: "challan_no",
      status: "same",
    },
    url: SERVER_URL + "/branch/add/",
    methodType: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      //   if (!text.challan_no) {
      //     console.log("In fff");
      //     throw new Error("The required value must be a number fff");
      //   }
    },
    additionalFilterOnInput: (inputObject) => {
      let dummyObject = lodash.cloneDeep(inputObject);

      dummyObject.is_branch = 0;

      if (!dummyObject.state || dummyObject.state.trim() === "") {
        throw new Error("State Name is required and cannot be empty.");
      }

      for (let key in dummyObject) {
        if (dummyObject[key] === "") {
          dummyObject[key] = null;
        }
      }

      return dummyObject;
    },
  },
  modifySubStationMaster: {
    paramSchema: {
      vehicle_no: "same",
      suffix: "same",
      pan_no: "same",
      owner_name: "same",
      owner_address: "same",
      body_type: "same",
      engine_no: "same",
      chasis_no: "same",
      permit_no: "same",
      permit_validity: "same",
      insurance_company: "same",
      policy_validity: "same",
      policy_no: "same",
      driver_name: "same",
      driver_address: "same",
      license_no: "same",
      license_validity: "same",
      created_from: "same",
      created_by: "same",
      freight_lock: "same",
      to_pay_account_name: "same",
      to_pay_account_id: "to_pay_account",
      is_agency: "same",
      state: "same",
      is_branch: "same",
      is_deleted: "same"
    },
    responseSchema: {
      booking_chalan_no: "challan_no",
      status: "same",
    },
    url: SERVER_URL + "/vehicle/",
    methodType: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      //   if (!text.challan_no) {
      //     console.log("In fff");
      //     throw new Error("The required value must be a number fff");
      //   }
    },
    additionalFilterOnInput: (inputObject) => {
      let dummyObject = lodash.cloneDeep(inputObject);
      dummyObject.is_branch = 0;
      for (let key in dummyObject) {
        if (dummyObject[key] == "") {
          dummyObject[key] = null;
        }
      }
      return dummyObject;
    },
  },
  getConsignorSuggestions: {
    url: SERVER_URL + "/consignor/",
    methodType: "GET",
    respoonseSchema: {},
  },
};


const crossingInApiConfig = {
  getCrossingIn: {
    responseSchema: {
      transporter_name: "same",
      transporter_id: "same",
      transporter_freight: "same",
      freight: "our_freight",
      total_pkgs: "pkgs",
      balance: "same",
      bilty_info: "bilty_ids",
      created_from: "same",
      created_by: "same",
      to_pay: "same",
      memo_no: "same",
      crossing_inward_date: "input_date",
      // last_mr_no: "",
      crossing_bill_no: "same",
      id: "same",
      paid: "same",
      fyear: "fYear_get",
    },
    url: SERVER_URL + "/crossing_inward/",
    methodType: "GET",
    additionalFilterOnResponse: (inputObject) => {
      console.log("Input objecy", inputObject);
      let tran_freight = 0;
      let our_freight = 0;
      let to_pay = 0;
      let paid = 0;
      let pkgs = 0;
      let biltyObj = {};
      for (let i = 0; i < inputObject.bilty_info.length; i++) {
        biltyObj = inputObject.bilty_info[i];
        tran_freight += parseInt(biltyObj.transporter_freight) || 0;
        our_freight += parseInt(biltyObj.total_amount) || 0;
        if (biltyObj.pay_type == "1") {
          to_pay += parseInt(biltyObj.transporter_freight) || 0;
        } else {
          paid += parseInt(biltyObj.transporter_freight) || 0;
        }
        pkgs += parseInt(biltyObj.no_of_package) || 0;
      }
      inputObject.transporter_freight = String(tran_freight);
      inputObject.freight = String(our_freight);
      inputObject.total_pkgs = String(pkgs);
      inputObject.to_pay = String(to_pay);
      inputObject.paid = String(paid);
      inputObject.balance = String(our_freight - to_pay);
      console.log("Output object", inputObject, our_freight);
      return inputObject;
    },
  },
  saveCrossingIn: {
    paramSchema: {
      transporter_name: "same",
      transporter_id: "same",
      transporter_freight: "same",
      our_freight: "freight",
      pkgs: "total_pkgs",
      balance: "same",
      bilty_ids: "bilty_info",
      created_from: "same",
      created_by: "same",
      to_pay: "same",
      input_date: "crossing_inward_date",
      // last_mr_no: "",
      memo_no: "same",
      crossing_bill_no: "same",
      paid: "same",
      company_id: "companyId",
      fYear: "fyear",
      // crossing
    },
    responseSchema: {
      crossing_inward_no: "crossing_in_no",
      status: "same",
    },
    url: SERVER_URL + "/crossing_inward/",
    methodType: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      console.log("text", text);
      if (!text.crossing_in_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
    additionalFilterOnInput: (inputObject) => {
      let dummyObject = lodash.cloneDeep(inputObject);
      for (let key in dummyObject) {
        if (dummyObject[key] == "") {
          dummyObject[key] = null;
        }
      }
      return dummyObject;
    },
  },
  modifyCrossingIn: {
    paramSchema: {
      transporter_name: "same",
      transporter_id: "same",
      transporter_freight: "same",
      our_freight: "freight",
      pkgs: "total_pkgs",
      balance: "same",
      bilty_ids: "bilty_info",
      created_from: "same",
      created_by: "same",
      to_pay: "same",
      memo_no: "same",
      input_date: "crossing_inward_date",
      // last_mr_no: "",
      crossing_bill_no: "same",
      id: "id",
      paid: "same",
      company_id: "companyId",
      fYear_get: "fyear",
    },
    responseSchema: {
      crossing_inward_no: "crossing_in_no",
      status: "same",
    },
    url: SERVER_URL + "/crossing_inward/",
    methodType: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      if (!text.crossing_in_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
    additionalFilterOnInput: (inputObject) => {
      let dummyObject = lodash.cloneDeep(inputObject);
      for (let key in dummyObject) {
        if (dummyObject[key] == "") {
          dummyObject[key] = null;
        }
      }
      return dummyObject;
    },
  },
  getTransporterSuggestions: {
    url: SERVER_URL + "/transporter/",
    methodType: "POST",
    respoonseSchema: {},
  },
};

const crossingOutApiConfig = {
  getCitySuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/branch/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getCrossingOut: {
    responseSchema: {
      transporter_name: "same",
      transporter_id: "same",
      transporter_freight: "same",
      freight: "our_freight",
      total_pkgs: "pkgs",
      balance: "same",
      bilty_info: "bilty_ids",
      created_from: "same",
      created_by: "same",
      id: "same",
      to_pay: "same",
      total_extra_mr_freight: "same",
      station_to: "same",
      crossing_out_no: "crossing_outward_no",
      station_to_name: "same",
      crossing_outward_date: "input_date",
      // last_mr_no: "",
      crossing_bill_no: "same",
      paid: "same",
      our_freight: "same",
      cewb_no: "same",
      vehicle_no: "same",
      fyear: "fYear_get",
      crossing_total_weight:"same",
      crossing_less_wgt_by_pkg: "same",
      crossing_total_less_wgt: "same",
      crossing_bulky_goods_package: "same",
      crossing_bulky_goods_rate: "same",
      crossing_bulky_goods_amount: "same",
      crossing_hire: "same",
      crossing_dd: "same",
      manual_no: "same",
      paid_pf: "same",
      to_pay_pf: "same",
    },
    url: SERVER_URL + "/crossing_outward/",
    methodType: "GET",
    additionalFilterOnResponse: (inputObject) => {
      console.log("Input objecy", inputObject);
      try {
        let tran_freight = parseFloat(inputObject.transporter_freight) || 0;
        let our_freight = 0;
        let to_pay = 0;
        let paid = 0;
        let pkgs = 0;
        let biltyObj = {};
        for (let i = 0; i < inputObject.bilty_info.length; i++) {
          console.log("x");
          biltyObj = inputObject.bilty_info[i];
          console.log("Bilty obj", biltyObj);
          // tran_freight += parseInt(biltyObj.transporter_freight) || 0;

          /**
           * This condition is when bilty is taken into crossing inward
           * and given to crossing outward
           */
            if(process.env.REACT_APP_CLIENT == "nrab") {
              our_freight += parseInt(biltyObj.total_amount) || 0;
            } else {
              if (biltyObj.transporter_id != null) {
            our_freight += parseInt(biltyObj.transporter_freight) || 0;
          } else {
              if (biltyObj.pay_type != "4") {
                our_freight += parseInt(biltyObj.total_amount) || 0;
              }
            }
            }
          if (biltyObj.pay_type == "1") {
            if(process.env.REACT_APP_CLIENT == "nrab") {
              to_pay += parseInt(biltyObj.total_amount) || 0;
            } else {
                if (biltyObj.transporter_id != null) {
                  to_pay += parseInt(biltyObj.transporter_freight) || 0;
                } else {
                  to_pay += parseInt(biltyObj.total_amount) || 0;
                }
              }
          } else if (biltyObj.pay_type != "4") {
            paid += parseInt(biltyObj.total_amount) || 0;
          }
          pkgs += parseInt(biltyObj.no_of_package) || 0;
        }
        inputObject.our_freight = String(our_freight);
        inputObject.total_pkgs = String(pkgs);
        inputObject.to_pay = String(to_pay);
        inputObject.paid = String(paid);
        inputObject.balance = String(to_pay - tran_freight);
      } catch (e) {
        console.log("Error", e);
      }
      if (["avr", "std", "nptc", "bgtc", "arbuda", "bbac", "jtsa", "bvtc"].includes(process.env.REACT_APP_CLIENT)) {
        inputObject.extra_mr_freight = ""
      }
      return inputObject;
    },
  },
  saveCrossingOut: {
    paramSchema: {
      transporter_name: "same",
      transporter_id: "same",
      transporter_freight: "same",
      our_freight: "freight",
      pkgs: "total_pkgs",
      balance: "same",
      bilty_ids: "bilty_info",
      created_from: "same",
      created_by: "same",
      to_pay: "same",
      total_extra_mr_freight: "same",
      station_to: "same",
      input_date: "crossing_outward_date",
      // last_mr_no: "",
      crossing_bill_no: "same",
      crossing_out_no: "crossing_outward_no",
      paid: "same",
      company_id: "companyId",
      fYear: "fyear",
      consider_cwgt: "same",
      crossing_less_wgt_by_pkg: "same",
      crossing_total_less_wgt: "same",
      crossing_bulky_goods_package: "same",
      crossing_bulky_goods_rate: "same",
      crossing_total_weight: "same",
      crossing_bulky_goods_amount: "same",
      crossing_hire: "same",
      crossing_dd: "same",
      cewb_no: "same",
      vehicle_no: "same",
      manual_no: "same",
      paid_pf: "same",
      to_pay_pf: "same",
    },
    responseSchema: {
      crossing_outward_no: "crossing_out_no",
      status: "same",
    },
    url: SERVER_URL + "/crossing_outward/",
    methodType: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      console.log("text", text);
      if (!text.crossing_out_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
    additionalFilterOnInput: (inputObject) => {
      let dummyObject = lodash.cloneDeep(inputObject);
      for (let key in dummyObject) {
        if (dummyObject[key] == "") {
          if (["avr", "std", "nptc", "bgtc", "arbuda", "bbac", "jtsa", "bvtc"].includes(process.env.REACT_APP_CLIENT) && key === "crossing_dd") {
            dummyObject[key] = 0;
          } else {
            dummyObject[key] = null;
          }
        }
        if (process.env.REACT_APP_CLIENT === "guru") {
          if (key === "paid_pf" || key === "to_pay_pf") {
            const pfToInt = parseInt(dummyObject[key]);
            dummyObject[key] = isNaN(pfToInt) ? null : pfToInt; 
          }
        } else {
          delete dummyObject.paid_pf;
          delete dummyObject.to_pay_pf;
        }
      }
      return dummyObject;
    },
  },
  modifyCrossingOut: {
    paramSchema: {
      transporter_name: "same",
      transporter_id: "same",
      transporter_freight: "same",
      our_freight: "freight",
      pkgs: "total_pkgs",
      balance: "same",
      station_to_name: "same",
      station_to: "same",
      bilty_ids: "bilty_info",
      created_from: "same",
      created_by: "same",
      to_pay: "same",
      total_extra_mr_freight: "same",
      input_date: "crossing_outward_date",
      // last_mr_no: "",
      crossing_bill_no: "same",
      id: "id",
      crossing_out_no: "crossing_outward_no",
      paid: "same",
      company_id: "companyId",
      fYear_get: "fyear",
      consider_cwgt: "same",
      crossing_less_wgt_by_pkg: "same",
      crossing_total_less_wgt: "same",
      crossing_bulky_goods_package: "same",
      crossing_bulky_goods_rate: "same",
      crossing_total_weight: "same",
      crossing_bulky_goods_amount: "same",
      crossing_hire: "same",
      crossing_dd: "same",
      cewb_no: "same",
      vehicle_no: "same",
      manual_no: "same",
      paid_pf: "same",
      to_pay_pf: "same",
    },
    responseSchema: {
      crossing_outward_no: "crossing_out_no",
      status: "same",
    },
    url: SERVER_URL + "/crossing_outward/",
    methodType: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      if (!text.crossing_out_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
    additionalFilterOnInput: (inputObject) => {
      let dummyObject = lodash.cloneDeep(inputObject);
      for (let key in dummyObject) {
        if (dummyObject[key] == "") {
          dummyObject[key] = null;
        }
        if (process.env.REACT_APP_CLIENT === "guru") {
          if (key === "paid_pf" || key === "to_pay_pf") {
            const pfToInt = parseInt(dummyObject[key]);
            dummyObject[key] = isNaN(pfToInt) ? null : pfToInt; 
          }
        } else {
          delete dummyObject.paid_pf;
          delete dummyObject.to_pay_pf;
        }
      }
      return dummyObject;
    },
  },
  getTransporterSuggestions: {
    url: SERVER_URL + "/transporter/",
    methodType: "POST",
    respoonseSchema: {},
  },
  getConsignorSuggestions: {
    url: SERVER_URL + "/consignor/",
    methodType: "GET",
    respoonseSchema: {},
  },
  generateCewb: {
    url: SERVER_URL + "/crossing_outward/generate-cewb/",
    methodType: "POST",
    respoonseSchema: {},
  },
};

const consignorBillingApiConfig = {
  getCrossingBill: {
    responseSchema: {
      gst_amount: "same",
      cgst: "same",
      sgst: "same",
      igst: "same",
      pf: "same",
      other_amount: "same",
      lc_charge: "same",
      id: "same",
      consignor_name: "same",
      consignor_id: "same",
      consignor_gst: "same",
      total_amount: "same",
      add: "same",
      net_amount: "same",
      description1: "same",
      amt1: "same",
      description2: "same",
      bill_no: "same",
      amt2: "same",
      description3: "same",
      amt3: "same",
      hamali: "same",
      rto_charge: "same",
      detention_charge: "same",
      remarks: "same",
      bilty_charge: "same",
      bilty_detention: "same",
      loading_charge: "same",
      unloading_charge: "same",
      bilty_rto: "same",
      bilty_advance: "same",
      door_del_charge: "same",
      extra_hamali: "same",
      extra_percentage: "same",
      extra_percentage_amount: "same",
      bilty_info: "bilty_ids",
      created_from: "same",
      created_by: "same",
      date_to: "input_date",
      input_date_from: "input_date_from",
      bill_date: "same",
      amount: "gross_amount",
      edit_bill: "same",
      fyear: "fYear_get",
      hamali_charge: "same",
      rto_charge:"same",
      detention_charge:"same",
      remarks: "same",
      service_charge: "same",
      collection_charge: "same",
    },
    url: SERVER_URL + "/tbb_billing_statement/",
    methodType: "GET",
    additionalFilterOnResponse: (inputObject) => {
      let total_bilty_charge = 0
      let other_charge = 0
      let total = 0;
      for (let i = 0; i < inputObject.bilty_info.length; i++) {
        inputObject.bilty_info[i].checked = "1";
        total_bilty_charge += inputObject.bilty_info[i].bilty_charge
        other_charge += inputObject.bilty_info[i].other_amount
        total += parseInt(inputObject.bilty_info[i].total_amount)
      }
      inputObject.bilty_charge = total_bilty_charge
      if(process.env.REACT_APP_CLIENT == "xpress"){
        inputObject.total_amount = total
      }

      if (process.env.REACT_APP_CLIENT === "g_trans") {
        inputObject.lc_charge = inputObject.collection_charge;
      }

      if (process.env.REACT_APP_CLIENT === "bgtc") {
        if (inputObject.input_date_from) {
          inputObject.input_date_from = inputObject.input_date_from.split("T")[0];
        }
      }

      // inputObject.total_amount += other_charge
      // console.log("VJJJJJJJJJJJJ",total_bilty_charge,inputObject)
      return inputObject;
    },
  },
  getEwbInfo: {
    responseSchema: {
      consignor_id: "same",
      consignor_name: "same",
      consignee_name: "same",
      consignor_gst: "same",
      consignee_gst: "same",
      consignee_id: "same",
      goods_invoice_value: "same",
    },
    url: SERVER_URL + "/ewb/",
    methodType: "POST",
    additionalFilterOnResponse: additionalFilterOnResponseForGetEwb,
  },
  saveCrossingBill: {
    paramSchema: {
      gst_amount: "same",
      cgst: "same",
      sgst: "same",
      igst: "same",
      pf: "same",
      other_amount: "same",
      lc_charge: "same",
      id: "same",
      bill_no: "same",
      consignor_id: "same",
      total_amount: "same",
      add: "same",
      description1: "same",
      amt1: "same",
      description2: "same",
      amt2: "same",
      description3: "same",
      amt3: "same",
      bilty_charge: "same",
      bilty_detention: "same",
      loading_charge: "same",
      unloading_charge: "same",
      bilty_rto: "same",
      bilty_advance: "same",
      hamali: "same",
      rto_charge: "same",
      detention_charge: "same",
      remarks: "same",
      bilty_charge: "same",
      door_del_charge: "same",
      extra_hamali: "same",
      extra_percentage: "same",
      extra_percentage_amount: "same",
      net_amount: "same",
      bilty_ids: "bilty_info",
      created_from: "same",
      created_by: "same",
      input_date: "date_to",
      input_date_from: "input_date_from",
      bill_date: "same",
      // input_date: "same",
      gross_amount: "amount",
      company_id: "companyId",
      fYear: "fyear",
      hamali_charge: "same",
      rto_charge:"same",
      detention_charge:"same",
      remarks: "same",
      total_pkgs: "same",
      total_weight: "same",
    },
    responseSchema: {
      bill_no: "id",
    },
    url: SERVER_URL + "/tbb_billing_statement/",
    methodType: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    // validateResponse: (text) => {
    //   // We only throw the error if the incoming data status is not equal to "ok"
    //   if (!text.bilty_no) {
    //     console.log("In fff");
    //     throw new Error("The required value must be a number fff");
    //   }
    // },
    additionalFilterOnInput: (inputObject) => {
      if (inputObject.id == "") {
        inputObject.id = null;
      }
      if (inputObject.bill_no == "") {
        inputObject.bill_no = null;
      }

      if (inputObject.add == null || inputObject.add === "") {
        inputObject.add = 0;
      }

      if (process.env.REACT_APP_CLIENT == "g_trans") {
        if (inputObject.lc_charge) {
          inputObject.collection_charge = inputObject.lc_charge;
          // delete inputObject.lc_charge;
        }
      }
      
      if (inputObject.bilty_info && inputObject.bilty_info.length > 0) {
        inputObject.bilty_info.forEach(item => {
          if (item.other_amount) {
            inputObject.service_charge = item.other_amount; 
            // delete item.other_amount; 
          }
        });
      }
      let dummyArray = [];
      for (let i = 0; i < inputObject.bilty_info.length; i++) {
        if (inputObject.bilty_info[i].checked == "1") {
          dummyArray.push(inputObject.bilty_info[i]);
        }
      }
      inputObject.bilty_info = dummyArray;
      return inputObject;
    },
  },
  modifyCrossingBill: {
    paramSchema: {
      gst_amount: "same",
      cgst: "same",
      sgst: "same",
      igst: "same",
      pf: "same",
      other_amount: "same",
      lc_charge: "same",
      id: "same",
      bill_no: "same",
      consignor_id: "same",
      total_amount: "same",
      add: "same",
      bill_no: "same",
      description1: "same",
      amt1: "same",
      description2: "same",
      amt2: "same",
      description3: "same",
      amt3: "same",
      bilty_charge: "same",
      hamali: "same",
      rto_charge: "same",
      detention_charge: "same",
      remarks: "same",
      bilty_charge: "same",
      bilty_detention: "same",
      loading_charge: "same",
      unloading_charge: "same",
      bilty_rto: "same",
      bilty_advance: "same",
      door_del_charge: "same",
      extra_hamali: "same",
      extra_percentage: "same",
      extra_percentage_amount: "same",
      net_amount: "same",
      bilty_ids: "bilty_info",
      created_from: "same",
      created_by: "same",
      input_date: "date_to",
      input_date_from: "input_date_from",
      bill_date: "same",
      // input_date: "same",
      gross_amount: "amount",
      company_id: "companyId",
      fYear_get: "fyear",
      hamali_charge: "same",
      rto_charge:"same",
      detention_charge:"same",
      remarks: "same",
      service_charge: "same",
      collection_charge: "same",
      total_pkgs: "same",
      total_weight: "same",
    },
    responseSchema: {
      bill_no: "id",
    },
    url: SERVER_URL + "/tbb_billing_statement/",
    methodType: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    // validateResponse: (text) => {
    //   // We only throw the error if the incoming data status is not equal to "ok"
    //   if (!text.bilty_no) {
    //     console.log("In fff");
    //     throw new Error("The required value must be a number fff");
    //   }
    // },
    additionalFilterOnInput: (inputObject) => {
      if (inputObject.id == "") {
        inputObject.id = null;
      }
      if (inputObject.add == null || inputObject.add === "") {
        inputObject.add = 0;
      }
      let dummyArray = [];
      for (let i = 0; i < inputObject.bilty_info.length; i++) {
        if (inputObject.bilty_info[i].checked == "1") {
          dummyArray.push(inputObject.bilty_info[i]);
        }
      }
      inputObject.bilty_info = dummyArray;
      return inputObject;
    },
  },
  getConsignorSuggestions: {
    url: SERVER_URL + "/consignor/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getConsigneeSuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/consignee/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getConsigneeSuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/consignee/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getItemSuggestions: {
    url: SERVER_URL + "/item/id",
    methodType: "POST",
    respoonseSchema: {},
    tailTruncate: true,
  },
  getTransporterSuggestions: {
    url: SERVER_URL + "/transporter/",
    methodType: "POST",
    respoonseSchema: {},
  },
};

const podStatementApiConfig = {
  getPage: {
    responseSchema: {
      consignor_id: "same",
      // total_amount: "same",
      // add: "same",
      // net_amount: "same",
      id: "same",
      consignor_name: "same",
      consignor_gst: "same",
      pod_list: "pod_info_list",
      created_from: "same",
      created_by: "same",
      created_date: "input_date",
      // amount: "same",
      fyear: "fYear_get",
      pod_statement_receive_date: "same",
      pod_receive_date_selected: "same",
    },
    url: SERVER_URL + "/pod_statement/",
    methodType: "GET",
    // additionalFilterOnResponse: (inputObject) => {
    //   console.log("Input object", inputObject);
    // //   if(typeof inputObject.pod_receive_date != "date") {
    // //         inputObject.pod_receive_date_selected = "false";
    // //   }
    // //   else
    //   return inputObject;
    // },
  },
  savePage: {
    paramSchema: {
      consignor_id: "same",
      // total_amount: "same",
      //   add: "same",
      // net_amount: "same",
      pod_info_list: "same",
      created_from: "same",
      created_by: "same",
      input_date: "same",
      // amount: "same",
      company_id: "companyId",
      fYear: "fyear",
      pod_statement_receive_date: "same",
      pod_receive_date_selected: "pod_receive_date_selected",
      id: "same",
    },
    responseSchema: {
      pod_statement_no: "same",
    },
    url: SERVER_URL + "/pod_statement/",
    methodType: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    additionalFilterOnInput: (inpObj) => {
      console.log(inpObj);

      if (inpObj.pod_receive_date_selected == "true") {
        console.log("inside");

        var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
        var localISOTime = new Date(
          new Date(inpObj.pod_statement_receive_date).getTime() - tzoffset
        )
          .toISOString()
          .slice(0, -1);
        console.log({ localISOTime });

        inpObj.pod_statement_receive_date = localISOTime;
      } else {
        inpObj.pod_statement_receive_date = null;
      }

      return inpObj;
    },
    // validateResponse: (text) => {
    //   // We only throw the error if the incoming data status is not equal to "ok"
    //   if (!text.bilty_no) {
    //     console.log("In fff");
    //     throw new Error("The required value must be a number fff");
    //   }
    // },
    // additionalFilterOnInput: additionalFilterOnInputForBilty,
  },
  modifyPage: {
    paramSchema: {
      consignor_id: "same",
      // total_amount: "same",
      // add: "same",
      // net_amount: "same",
      pod_info_list: "same",
      created_from: "same",
      created_by: "same",
      input_date: "same",
      id: "same",
      // amount: "same",
      company_id: "companyId",
      fYear_get: "fyear",
      pod_statement_receive_date: "same",
    },
    responseSchema: {
      bilty_no: "same",
    },
    url: SERVER_URL + "/pod_statement/",
    methodType: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      if (!text.bilty_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
    additionalFilterOnInput: additionalFilterOnInputForBilty,
  },
  getConsignorSuggestions: {
    url: SERVER_URL + "/consignor/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getConsigneeSuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/consignee/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getConsigneeSuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/consignee/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getItemSuggestions: {
    url: SERVER_URL + "/item/id",
    methodType: "POST",
    respoonseSchema: {},
    tailTruncate: true,
  },
  getTransporterSuggestions: {
    url: SERVER_URL + "/transporter/",
    methodType: "POST",
    respoonseSchema: {},
  },
};

const crossingBillingApiConfig = {
  getCrossingBill: {
    responseSchema: {
      transporter_id: "same",
      transporter_name: "same",
      total_amount: "same",
      // add: "same",
      net_amount: "same",
      crossing_info: "same",
      created_from: "same",
      created_by: "same",
      bill_date: "input_date",
      net_amount: "same",
      type: "same",
      id: "same",
      add: "same",
      remarks: "same",
      date_to: "same",
      date_from: "same",
      fyear: "fYear_get",
      transporter_gst: "same"
    },
    url: SERVER_URL + "/crossing_bill_in/",
    methodType: "GET",
    // additionalFilterOnResponse: (inputObject) => {
    //   console.log("Input object", inputObject);
    //   if (inputObject.eway_bill_info.length == 0) {
    //     inputObject.eway_bill_info = [
    //       {
    //         eway_bill_no: "",
    //         new_row: "N",
    //       },
    //     ];
    //   }
    //   return inputObject;
    // },
  },
  getCrossingBillOut: {
    responseSchema: {
      transporter_id: "same",
      transporter_name: "same",
      total_amount: "same",
      // add: "same",
      net_amount: "same",
      crossing_info: "same",
      created_from: "same",
      created_by: "same",
      bill_date: "input_date",
      net_amount: "same",
      type: "same",
      id: "same",
      add: "same",
      remarks: "same",
      date_to: "same",
      date_from: "same",
      fyear: "fYear_get",
      transporter_gst: "same"
    },
    url: SERVER_URL + "/crossing_bill_out/",
    methodType: "GET",
    // additionalFilterOnResponse: (inputObject) => {
    //   console.log("Input object", inputObject);
    //   if (inputObject.eway_bill_info.length == 0) {
    //     inputObject.eway_bill_info = [
    //       {
    //         eway_bill_no: "",
    //         new_row: "N",
    //       },
    //     ];
    //   }
    //   return inputObject;
    // },
  },
  getEwbInfo: {
    responseSchema: {
      consignor_id: "same",
      consignor_name: "same",
      consignee_name: "same",
      consignor_gst: "same",
      consignee_gst: "same",
      consignee_id: "same",
      goods_invoice_value: "same",
    },
    url: SERVER_URL + "/ewb/",
    methodType: "POST",
    additionalFilterOnResponse: additionalFilterOnResponseForGetEwb,
  },
  saveCrossingBillIn: {
    paramSchema: {
      transporter_id: "same",
      total_amount: "same",
      // add: "same",
      net_amount: "same",
      crossing_info: "same",
      created_from: "same",
      created_by: "same",
      date_to: "same",
      date_from: "same",
      crossing_inward_date: "same",
      net_amount: "same",
      // type: "same",
      input_date: "bill_date",
      add: "same",
      remarks: "same",
      company_id: "companyId",
      fYear: "fyear",
    },
    responseSchema: {
      bill_no: "same",
    },
    url: SERVER_URL + "/crossing_bill_in/",
    methodType: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    // validateResponse: (text) => {
    //   // We only throw the error if the incoming data status is not equal to "ok"
    //   if (!text.bilty_no) {
    //     console.log("In fff");
    //     throw new Error("The required value must be a number fff");
    //   }
    // },
    // additionalFilterOnInput: additionalFilterOnInputForBilty,
  },
  saveCrossingBillOut: {
    paramSchema: {
      transporter_id: "same",
      total_amount: "same",
      // add: "same",
      net_amount: "same",
      crossing_info: "same",
      created_from: "same",
      created_by: "same",
      date_to: "same",
      date_from: "same",
      crossing_outward_date: "same",
      net_amount: "same",
      // type: "same",
      input_date: "bill_date",
      add: "same",
      remarks: "same",
      company_id: "companyId",
      fYear: "fyear",
    },
    responseSchema: {
      bill_no: "same",
    },
    url: SERVER_URL + "/crossing_bill_out/",
    methodType: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    // validateResponse: (text) => {
    //   // We only throw the error if the incoming data status is not equal to "ok"
    //   if (!text.bilty_no) {
    //     console.log("In fff");
    //     throw new Error("The required value must be a number fff");
    //   }
    // },
    additionalFilterOnInput: additionalFilterOnInputForBilty,
  },
  modifyCrossingBillIn: {
    paramSchema: {
      transporter_id: "same",
      total_amount: "same",
      // add: "same",
      net_amount: "same",
      crossing_info: "same",
      created_from: "same",
      created_by: "same",
      date_from: "same",
      date_to: "same",
      crossing_inward_date: "same",
      net_amount: "same",
      // type: "same",
      input_date: "bill_date",
      id: "same",
      add: "same",
      remarks: "same",
      company_id: "companyId",
      fYear_get: "fyear",
    },
    responseSchema: {
      bill_no: "same",
    },
    url: SERVER_URL + "/crossing_bill_in/",
    methodType: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    // validateResponse: (text) => {
    //   // We only throw the error if the incoming data status is not equal to "ok"
    //   if (!text.bill) {
    //     console.log("In fff");
    //     throw new Error("The required value must be a number fff");
    //   }
    // },
    // additionalFilterOnInput: additionalFilterOnInputForBilty,
  },
  modifyCrossingBillOut: {
    paramSchema: {
      transporter_id: "same",
      total_amount: "same",
      // add: "same",
      net_amount: "same",
      crossing_info: "same",
      created_from: "same",
      created_by: "same",
      date_from: "same",
      date_to: "same",
      crossing_outward_date: "same",
      net_amount: "same",
      // type: "same",
      input_date: "bill_date",
      id: "same",
      add: "same",
      remarks: "same",
      company_id: "companyId",
      fYear_get: "fyear",
    },
    responseSchema: {
      bill_no: "same",
    },
    url: SERVER_URL + "/crossing_bill_out/",
    methodType: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    // validateResponse: (text) => {
    //   // We only throw the error if the incoming data status is not equal to "ok"
    //   if (!text.bilty_no) {
    //     console.log("In fff");
    //     throw new Error("The required value must be a number fff");
    //   }
    // },
    additionalFilterOnInput: additionalFilterOnInputForBilty,
  },
  getConsignorSuggestions: {
    url: SERVER_URL + "/consignor/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getConsigneeSuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/consignee/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getConsigneeSuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/consignee/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getItemSuggestions: {
    url: SERVER_URL + "/item/id",
    methodType: "POST",
    respoonseSchema: {},
    tailTruncate: true,
  },
  getTransporterSuggestions: {
    url: SERVER_URL + "/transporter/",
    methodType: "POST",
    respoonseSchema: {},
  },
};

const tripBhadaApiConfig = {
  getTripBhada: {
    responseSchema: {
      vehicle_id: "same",
      vehicle_no: "same",
      owner_name: "same",
      driver_name: "same",
      created_from: "same",
      remarks: "same",
      created_by: "same",
      trip_info: "same",
      amount: "same",
      input_date: "trip_bhada_date",
      receiver_name: "same",
      id: "trip_bhada_no",
    },
    url: SERVER_URL + "/trip_bhada/",
    methodType: "GET",
    additionalFilterOnResponse: (inputObject) => {
      let amount = 0;
      let temp_amount = 0;
      for (let i = 0; i < inputObject.trip_info.length; i++) {
        temp_amount = parseInt(inputObject.trip_info[i].balance_bhada) || 0;
        amount += temp_amount;
      }
      inputObject.amount = amount;
      return inputObject;
    },
  },
  saveTripBhada: {
    paramSchema: {
      vehicle_id: "same",
      created_from: "same",
      remarks: "same",
      created_by: "same",
      trip_info: "same",
      amount: "same",
      input_date: "trip_bhada_date",
      receiver_name: "same",
    },
    responseSchema: {
      id: "trip_bhada_no",
      status: "same",
    },
    url: SERVER_URL + "/trip_bhada/",
    methodType: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      if (!text.trip_bhada_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
    // additionalFilterOnInput: (inputObject) => {
    //     if (inputObject.eway_bill_info &&
    //         inputObject.eway_bill_info.length==1 &&
    //         inputObject.eway_bill_info[0].eway_bill_no == ""){
    //         delete inputObject.eway_bill_info
    //     }
    //     return inputObject;
    // },
  },
  modifyTripBhada: {
    paramSchema: {
      vehicle_id: "same",
      created_from: "same",
      remarks: "same",
      created_by: "same",
      trip_info: "same",
      amount: "same",
      input_date: "trip_bhada_date",
      receiver_name: "same",
      trip_bhada_no: "id",
    },
    responseSchema: {
      id: "trip_bhada_no",
      status: "same",
    },
    url: SERVER_URL + "/trip_bhada/",
    methodType: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      if (!text.trip_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
    // additionalFilterOnInput: (inputObject) => {
    //     if (inputObject.eway_bill_info &&
    //         inputObject.eway_bill_info.length==1 &&
    //         inputObject.eway_bill_info[0].eway_bill_no == ""){
    //         delete inputObject.eway_bill_info
    //     }
    //     return inputObject;
    // },
  },
  getVehicleSuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/vehicle/",
    methodType: "GET",
    respoonseSchema: {},
  },
};

const partyRateMasterApiConfig = {
  savePartyRateMaster: {
    paramSchema: {
      rate_info: "same",
      charge_info: "same",
      consignor_id: "same",
    },
    // responseSchema: {
    //   bilty_no: "same",
    // },
    url: SERVER_URL + "/party_rate/",
    methodType: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    // validateResponse: (text) => {
    //   // We only throw the error if the incoming data status is not equal to "ok"
    //   // if (!text.bilty_no) {
    //   //   console.log("In fff");
    //   //   throw new Error("The required value must be a number fff");
    //   // }
    // },
    additionalFilterOnInput: (inputObject) => {
      for (let i = 0; i < inputObject.rate_info.length; i++) {
        for (let key in inputObject.rate_info[i]) {
          if (inputObject.rate_info[i][key] == "") {
            inputObject.rate_info[i][key] = null;
          }
        }
      }
      return inputObject;
    },
  },
  getCitySuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/branch/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getConsignorSuggestions: {
    url: SERVER_URL + "/consignor/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getConsigneeSuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/consignee/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getConsigneeSuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/consignee/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getItemSuggestions: {
    url: SERVER_URL + "/item/",
    methodType: "POST",
    respoonseSchema: {},
    // tailTruncate: true,
  },
  getTransporterSuggestions: {
    url: SERVER_URL + "/transporter/",
    methodType: "POST",
    respoonseSchema: {},
  },
};

const generalRateMasterApiConfig = {
  getBilty: {
    responseSchema: {
      no_of_package: "same",
      bilty_no: "same",
      other_amount: "same",
      actual_weight: "same",
      freight: "same",
      station_from: "same",
      charge_weight: "same",
      station_to: "same",
      hamali: "same",
      packing_type: "same",
      destination: "same",
      door_del_charge: "same",
      private_marka_no: "same",
      pay_type: "same",
      goods_invoice_value: "same",
      consignor_id: "same",
      delivery_dest_type: "same",
      bilty_id: "same",
      consignee_id: "same",
      remarks: "same",
      bilty_charge: "same",
      consignor_name: "same",
      consignee_name: "same",
      consignor_gst: "same",
      consignee_gst: "same",
      station_from_name: "same",
      station_to_name: "same",
      destination_name: "same",
      item_info: "item_in",
      eway_bill_info: "eway_bill_no",
      is_deleted: "same",
      bilty_date: "input_date",
      booking_chalan_no: "same",
      mr_no: "same",
      trip_no: "same",
      total_amount: "same",
      transporter_id: "same",
      transporter_name: "same",
      suffix: "same",
      transporter_freight: "same",
      crossing_inward_no: "same",
    },
    url: SERVER_URL + "/bilty/",
    methodType: "GET",
    additionalFilterOnResponse: (inputObject) => {
      console.log("Input object", inputObject);
      if (inputObject.eway_bill_info.length == 0) {
        inputObject.eway_bill_info = [
          {
            eway_bill_no: "",
            new_row: "N",
          },
        ];
      }
      return inputObject;
    },
  },
  getEwbInfo: {
    responseSchema: {
      consignor_id: "same",
      consignor_name: "same",
      consignee_name: "same",
      consignor_gst: "same",
      consignee_gst: "same",
      consignee_id: "same",
      goods_invoice_value: "same",
    },
    url: SERVER_URL + "/ewb/",
    methodType: "POST",
    additionalFilterOnResponse: additionalFilterOnResponseForGetEwb,
  },
  saveGeneralRateMaster: {
    paramSchema: {
      station_from: "same",
      station_to: "same",
      rate_info: "same",
      consignee_id: "consignee",
    },
    responseSchema: {
      bilty_no: "same",
    },
    url: SERVER_URL + "/general_rate/",
    methodType: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      // if (!text.bilty_no) {
      //   console.log("In fff");
      //   throw new Error("The required value must be a number fff");
      // }
    },
    additionalFilterOnInput: (inputObject) => {
      if (inputObject.station_to === "" || inputObject.station_to === undefined) {
        inputObject.station_to = null;
      }
      if (Array.isArray(inputObject.rate_info)) {
        inputObject.rate_info = inputObject.rate_info.map((rateInfo) => ({
          ...rateInfo,
          station_to:
            rateInfo.station_to === "" || rateInfo.station_to === undefined
              ? null
              : rateInfo.station_to,
          consignee:
            rateInfo.consignee === "" || rateInfo.consignee === undefined
              ? null
              : rateInfo.consignee,
          consignor:
            rateInfo.consignor === "" || rateInfo.consignor === undefined
              ? null
              : rateInfo.consignor,
          consignor_id:
            rateInfo.consignor_id === "" || rateInfo.consignor_id === undefined
              ? null
              : rateInfo.consignor_id,
        }));
      }

      return inputObject;
    },
  },
  modifyBilty: {
    paramSchema: {
      no_of_package: "same",
      bilty_no: "same",
      other_amount: "same",
      actual_weight: "same",
      freight: "same",
      station_from: "same",
      charge_weight: "same",
      station_to: "same",
      hamali: "same",
      packing_type: "same",
      destination: "same",
      door_del_charge: "same",
      private_marka_no: "same",
      pay_type: "same",
      goods_invoice_value: "same",
      consignor_id: "same",
      delivery_dest_type: "same",
      // "bilty_id": "same",
      consignee_id: "same",
      remarks: "same",
      bilty_charge: "same",
      consignor_name: "same",
      consignee_name: "same",
      consignor_gst: "same",
      consignee_gst: "same",
      station_from_name: "same",
      station_to_name: "same",
      destination_name: "same",
      item_in: "same",
      created_by: "same",
      created_from: "same",
      delivery_dest_type: "same",
      pay_type: "same",
      packing_type: "same",
      // "is_printed": "same",
      eway_bill_no: "eway_bill_info",
      input_date: "bilty_date",
      total_amount: "same",
      total_amount: "same",
      transporter_id: "same",
      transporter_name: "same",
      suffix: "same",
      transporter_freight: "same",
      is_crossing: "same",
    },
    responseSchema: {
      bilty_no: "same",
    },
    url: SERVER_URL + "/bilty/",
    methodType: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      if (!text.bilty_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
    additionalFilterOnInput: additionalFilterOnInputForBilty,
  },
  getCitySuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/branch/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getConsignorSuggestions: {
    url: SERVER_URL + "/consignor/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getConsigneeSuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/consignee/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getConsigneeSuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/consignee/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getItemSuggestions: {
    url: SERVER_URL + "/item/",
    methodType: "POST",
    respoonseSchema: {},
    // tailTruncate: true,
  },
  getTransporterSuggestions: {
    url: SERVER_URL + "/transporter/",
    methodType: "POST",
    respoonseSchema: {},
  },
};

const accountReportApiConfig = {
  getBilty: {
    responseSchema: {
      no_of_package: "same",
      bilty_no: "same",
      other_amount: "same",
      actual_weight: "same",
      freight: "same",
      station_from: "same",
      charge_weight: "same",
      station_to: "same",
      hamali: "same",
      packing_type: "same",
      destination: "same",
      door_del_charge: "same",
      private_marka_no: "same",
      pay_type: "same",
      goods_invoice_value: "same",
      consignor_id: "same",
      delivery_dest_type: "same",
      bilty_id: "same",
      consignee_id: "same",
      remarks: "same",
      bilty_charge: "same",
      consignor_name: "same",
      consignee_name: "same",
      consignor_gst: "same",
      consignee_gst: "same",
      station_from_name: "same",
      station_to_name: "same",
      destination_name: "same",
      item_info: "item_in",
      eway_bill_info: "eway_bill_no",
      is_deleted: "same",
      bilty_date: "input_date",
      booking_chalan_no: "same",
      mr_no: "same",
      trip_no: "same",
      total_amount: "same",
      transporter_id: "same",
      transporter_name: "same",
      suffix: "same",
      transporter_freight: "same",
      crossing_inward_no: "same",
    },
    url: SERVER_URL + "/bilty/",
    methodType: "GET",
    additionalFilterOnResponse: (inputObject) => {
      console.log("Input object", inputObject);
      if (inputObject.eway_bill_info.length == 0) {
        inputObject.eway_bill_info = [
          {
            eway_bill_no: "",
            new_row: "N",
          },
        ];
      }
      return inputObject;
    },
  },
  getEwbInfo: {
    responseSchema: {
      consignor_id: "same",
      consignor_name: "same",
      consignee_name: "same",
      consignor_gst: "same",
      consignee_gst: "same",
      consignee_id: "same",
      goods_invoice_value: "same",
    },
    url: SERVER_URL + "/ewb/",
    methodType: "POST",
    additionalFilterOnResponse: additionalFilterOnResponseForGetEwb,
  },
  saveGeneralRateMaster: {
    paramSchema: {
      station_from: "same",
      station_to: "same",
      rate_info: "same",
      company_id: "companyId",
      fYear: "fyear",
    },
    responseSchema: {
      bilty_no: "same",
    },
    url: SERVER_URL + "/general_rate/",
    methodType: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      // if (!text.bilty_no) {
      //   console.log("In fff");
      //   throw new Error("The required value must be a number fff");
      // }
    },
    additionalFilterOnInput: (inputObject) => {
      if (inputObject.station_to === "" || inputObject.station_to === undefined) {
        inputObject.station_to = null;
      }
      if (Array.isArray(inputObject.rate_info)) {
        inputObject.rate_info = inputObject.rate_info.map((rateInfo) => ({
          ...rateInfo,
          station_to:
            rateInfo.station_to === "" || rateInfo.station_to === undefined
              ? null
              : rateInfo.station_to,
          consignee:
            rateInfo.consignee === "" || rateInfo.consignee === undefined
              ? null
              : rateInfo.consignee,
          consignor:
            rateInfo.consignor === "" || rateInfo.consignor === undefined
              ? null
              : rateInfo.consignor,
          consignor_id:
            rateInfo.consignor_id === "" || rateInfo.consignor_id === undefined
              ? null
              : rateInfo.consignor_id,
        }));
      }

      return inputObject;
    },
  },
  modifyBilty: {
    paramSchema: {
      no_of_package: "same",
      bilty_no: "same",
      other_amount: "same",
      actual_weight: "same",
      freight: "same",
      station_from: "same",
      charge_weight: "same",
      station_to: "same",
      hamali: "same",
      packing_type: "same",
      destination: "same",
      door_del_charge: "same",
      private_marka_no: "same",
      pay_type: "same",
      goods_invoice_value: "same",
      consignor_id: "same",
      delivery_dest_type: "same",
      // "bilty_id": "same",
      consignee_id: "same",
      remarks: "same",
      bilty_charge: "same",
      consignor_name: "same",
      consignee_name: "same",
      consignor_gst: "same",
      consignee_gst: "same",
      station_from_name: "same",
      station_to_name: "same",
      destination_name: "same",
      item_in: "same",
      created_by: "same",
      created_from: "same",
      delivery_dest_type: "same",
      pay_type: "same",
      packing_type: "same",
      // "is_printed": "same",
      eway_bill_no: "eway_bill_info",
      input_date: "bilty_date",
      total_amount: "same",
      total_amount: "same",
      transporter_id: "same",
      transporter_name: "same",
      suffix: "same",
      transporter_freight: "same",
      is_crossing: "same",
      company_id: "companyId",
      fYear: "fyear",
    },
    responseSchema: {
      bilty_no: "same",
    },
    url: SERVER_URL + "/bilty/",
    methodType: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    validateResponse: (text) => {
      // We only throw the error if the incoming data status is not equal to "ok"
      if (!text.bilty_no) {
        console.log("In fff");
        throw new Error("The required value must be a number fff");
      }
    },
    additionalFilterOnInput: additionalFilterOnInputForBilty,
  },
  getCitySuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/branch/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getConsignorSuggestions: {
    url: SERVER_URL + "/consignor/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getConsigneeSuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/consignee/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getConsigneeSuggestions: {
    paramSchema: {},
    url: SERVER_URL + "/consignee/",
    methodType: "GET",
    respoonseSchema: {},
  },
  getItemSuggestions: {
    url: SERVER_URL + "/item/",
    methodType: "POST",
    respoonseSchema: {},
    // tailTruncate: true,
  },
  getTransporterSuggestions: {
    url: SERVER_URL + "/transporter/",
    methodType: "POST",
    respoonseSchema: {},
  },
};

export {
  biltyApiConfig,
  challanApiConfig,
  podChallanApiConfig,
  mrInquiryApiConfig,
  vehicleRegisterApiConfig,
  mrApiConfig,
  tripApiConfig,
  tripExtendedApiConfig,
  tripBhadaApiConfig,
  challanInwardApiConfig,
  biltyStatementApiConfig,
  mrStatementApiConfig,
  podChallanInwardApiConfig,
  vehicleApiConfig,
  crossingInApiConfig,
  accountMasterApiConfig,
  crossingOutApiConfig,
  itemMasterApiConfig,
  stationMasterApiConfig,
  consignorBillingApiConfig,
  crossingBillingApiConfig,
  partyRateMasterApiConfig,
  generalRateMasterApiConfig,
  accountReportApiConfig,
  podStatementApiConfig,
  biltyInquiryApiConfig,
  accountTransactionApiConfig,
  BrokerageSummaryApiConfig,
  BankClearanceApiConfig,
  NarrationMasterApiConfig,
  GroupMasterApiConfig,
  SubgroupMasterApiConfig,
  separateEwbApiConfig,
  mrPendingAmountApiConfig,
  fleetApiConfig,
  stockOutwardApiConfig,
  stockInwardApiConfig,
  mrBillingApiConfig,
  lrMasterApiConfig,
  analysisReportApiConfig,
  marfatiyaApiConfig,
  SubStationMasterApiConfig
};
